
// 12 версия пока кроме отмен с бара не вижу проблем в логике и подсчете ходов
import React, { useEffect, useState, useCallback,useRef,useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, useLocation } from 'react-router-dom';
// Важно: используем "tournamentSocket" (namespace '/tournament'), а НЕ обычный "socket".
import tournamentSocket from './tournamentSocket';
import MatchResultModal from "./MatchResultModal";
import MatchResultModalV2 from "./MatchResultModalV2";
import { useGame } from './context/GameContext';
import TournamentBoardDisplay from './TournamentBoardDisplay';

import { useNavigate } from 'react-router-dom';

/**
 * Сервер может присылать броски в разных форматах:
 *
 * [4]             — стартовый бросок одного игрока;
 * [4, 2]          — обычная пара кубиков;
 * [[4, 2]]        — история с одной парой;
 * [4, [6, 3]]     — стартовый кубик и последующий бросок.
 *
 * Функция всегда возвращает последний бросок массивом.
 */
function normalizeTournamentDice(value) {
  if (!Array.isArray(value) || value.length === 0) {
    return [];
  }

  const lastValue = value[value.length - 1];

  const dice = Array.isArray(lastValue)
    ? lastValue
    : value;

  return dice
    .map((die) => Number(die))
    .filter(
      (die) =>
        Number.isInteger(die) &&
        die >= 1 &&
        die <= 6
    );
}


/**
 * Получает самый первый кубик игрока.
 * Он используется при стартовом определении очереди.
 */
function getTournamentOpeningDie(value) {
  if (!Array.isArray(value) || value.length === 0) {
    return null;
  }

  const firstValue = Array.isArray(value[0])
    ? value[0][0]
    : value[0];

  const die = Number(firstValue);

  if (
    !Number.isInteger(die) ||
    die < 1 ||
    die > 6
  ) {
    return null;
  }

  return die;
}


const TournamentMatch = () => {
  const { t: translate } = useTranslation();

  //////////////////////////////////////////////////////////////////////////
  // 1) Извлекаем :id из маршрута /tournamentMatch/:id
  //////////////////////////////////////////////////////////////////////////
  // const { id: tournamentMatchId } = useParams();

  //////////////////////////////////////////////////////////////////////////
  // 2) Считываем query-параметр tableId=? из URL
  //////////////////////////////////////////////////////////////////////////
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  // const tournamentTableId = queryParams.get('tableId');

const lastSentStateRef = useRef(null);

const askedBracketRef = useRef(false);



const params       = useParams();       // { id: '<gameId>' }



/**  ❗ tableId берём:
+ *      1) из ?tableId=...
+ *      2) если его нет — из сегмента пути :id   */
const tournamentTableId = Number(
  queryParams.get('tableId')      // приоритет — query‑строка
  ?? params.id                    // запасной вариант — :id
);
// gameId остаётся, если он нужен где‑то ещё:
const tournamentMatchId = Number(params.id);
const currentTurnRef = useRef(null);
const timerRef = useRef(null);
const isMyTurnRef = useRef(false);

// стадия турнира (например: "1/2 финала" или "Финал")
const [tournamentStageLabel, setTournamentStageLabel] = useState('');
// (опц.) сам id турнира, если шлёшь его с сервера
const [tournamentId, setTournamentId] = useState(null);
const [tournamentPrize, setTournamentPrize] = useState(null);

  //////////////////////////////////////////////////////////////////////////
  // 3) username из localStorage
  //////////////////////////////////////////////////////////////////////////
  const tournamentUsername = localStorage.getItem('username') || '';

  //////////////////////////////////////////////////////////////////////////
  // 4) Из контекста GameContext берём все методы и стейты, связанные с турниром
  //////////////////////////////////////////////////////////////////////////
  const {
    // Board / color / turn

    // Off-board
    tournamentWhiteOffBoard,    setTournamentWhiteOffBoard,
    tournamentBlackOffBoard,    setTournamentBlackOffBoard,

    // Captured, rolled dice, game, ...
    
    // tournamentGame,             setTournamentGame,
    tournamentFirstRollComplete, setTournamentFirstRollComplete, 
    tournamentFirstRolls,       setTournamentFirstRolls,
    tournamentRollEnabled, setTournamentRollEnabled,
    tournamentReadyStatus,      setTournamentReadyStatus,
    updateTournamentReadyStatus, 
    tournamentBoardState, setTournamentBoardState,
    tournamentPlayerColor, setTournamentPlayerColor,
    tournamentOpponentColor, setTournamentOpponentColor,tournamentCapturedCheckers, setTournamentCapturedCheckers,
    tournamentRolledDice, setTournamentRolledDice,tournamentUsedRolls, setTournamentUsedRolls,board,
    // Прочее
   
  } = useGame();


  //////////////////////////////////////////////////////////////////////////
  // Локальные состояния
  //////////////////////////////////////////////////////////////////////////
  const [tournamentLoading, setTournamentLoading] = useState(true);
  const [tournamentError,   setTournamentError]   = useState(null);
  const justConfirmedRef = useRef(false);
  // const [tournamentCurrentTurn,setTournamentCurrentTurn]   = useState([null]);
const [
  tournamentCurrentTurn,
  setTournamentCurrentTurn
] = useState(null);
  const [tournamentPlayer1Name,  setTournamentPlayer1Name]  = useState(null);
  const [tournamentPlayer2Name,  setTournamentPlayer2Name]  = useState(null);
  const [tournamentPlayer1Dice,  setTournamentPlayer1Dice]  = useState(null);
  const [tournamentPlayer2Dice,  setTournamentPlayer2Dice]  = useState(null);
  const [firstMoveComplete,  setFirstMoveComplete]  = useState(false);
  const [opponentRolledDice,  setOpponentRolledDice]  = useState(false);
  
  const [tournamentShowUndoButton, setTournamentShowUndoButton] = useState(false); // Отображение кнопки "Отменить ход"


  const [tournamentIsTie, setTournamentIsTie] = useState(false);
  const [tournamentShowFirstRollButton, setTournamentShowFirstRollButton] = useState(true);
  const [tournamentNumberMove, setTournamentNumberMove] = useState(2);


  const [tournamentMyUserId, setTournamentMyUserId] = useState(null);
  const [tournamentShowReadyButton, setTournamentShowReadyButton] = useState(false);



  const [countdown, setCountdown] = useState(null);
  const [rollButtonEnabled, setRollButtonEnabled] = useState(false);
  const [countdownMessage, setCountdownMessage] = useState('');



const [tournamentLastMoveType, setTournamentLastMoveType] = useState(null); // 'click' или 'drag'
const [tournamentLastMoveRoll, setTournamentLastMoveRoll] = useState(null); // Добавляем состояние для последнего значения кубика
const [tournamentMoveHistory, setTournamentMoveHistory] = useState([]); // Добавляем состояние для последнего значения кубика
const [undoCooldown, setUndoCooldown] = useState(false);


 const [tournamentHasRolledDice, setTournamentHasRolledDice] = useState(false)
 const [disableBoardClicks, setDisableBoardClicks] = useState(false);

 const hasAutoConfirmedRef = useRef(false);

 const [initialRollPhase, setInitialRollPhase] = useState(false);
 const [mustUseTwoMoves, setMustUseTwoMoves] = useState(false);
 const navigate = useNavigate();
 const [modalMessage, setModalMessage] = useState('');
 const [showModal, setShowModal] = useState(false);
const [lastOutcome, setLastOutcome] = useState(null); 



const [player1Time, setPlayer1Time] = useState(30); // или 30, если короткий
const [player2Time, setPlayer2Time] = useState(30);
const intervalRef = useRef(null);

const [autoRoll, setAutoRoll] = useState(false);
const [autoConfirm, setAutoConfirm] = useState(false);

// авы и рейтинги
const [player1Avatar, setPlayer1Avatar] = useState(null);
const [player2Avatar, setPlayer2Avatar] = useState(null);
const [player1ShortRating, setPlayer1ShortRating] = useState(1200);
const [player2ShortRating, setPlayer2ShortRating] = useState(1200);

const [bracketRounds, setBracketRounds] = useState([
  { label: "Полуфиналы", matches: [{ a: "—", b: "—" }, { a: "—", b: "—" }] },
  { label: "Финал",      matches: [{ a: "—", b: "—", winner: undefined }] },
]);





const isSemi = (label) => String(label || tournamentStageLabel).toLowerCase().includes("полуфин");
const isFinal = (label) => {
  const l = String(label || tournamentStageLabel).toLowerCase();
  return l.includes("финал") && !l.includes("полуфин");
};



function scoreWinner(p1, p2, s1, s2) {
  if (typeof s1 === 'number' && typeof s2 === 'number') {
    if (s1 === s2) return null;
    return s1 > s2 ? (p1 || null) : (p2 || null);
  }
  return null;
}

const patchRounds = (producer) => {
  setBracketRounds(prev => {
    const copy = prev.map(r => ({ 
      ...r, 
      matches: r.matches.map(m => ({ ...m }))
    }));
    producer(copy);
    return copy;
  });
};





const onToggleAutoRoll = useCallback(() => setAutoRoll(v => !v), []);
const onToggleAutoConfirm = useCallback(() => setAutoConfirm(v => !v), []);












const setFinalPair = (A, B) => patchRounds(rounds => {
  const fi = rounds.findIndex(r => isFinal(r.label));
  if (fi === -1) return;
  const m = { ...(rounds[fi].matches?.[0] || {}) };
  // rounds[fi].matches[0] = { ...m, a: p1(A) || m.a || "—", b: p2(B) || m.b || "—" };
  rounds[fi].matches[0] = {
     ...m,
     a: m.a && m.a !== "—" ? m.a : (p1(A) || "—"),
     b: m.b && m.b !== "—" ? m.b : (p2(B) || "—"),
   };
});


/** Проставить исход матча и при надобности автосформировать финал */
/** Проставить результат и, при отсутствии пар, апсертить их прямо здесь */
const applyMatchResult = ({ winner, loser, isFinal: finalFlag }) => patchRounds(rounds => {
  const inferLoser = (m) => {
    if (loser) return loser;
    if (!m) return undefined;
    if (m.a === winner) return m.b;
    if (m.b === winner) return m.a;
    return undefined;
  };

  // Вставляет/обновляет пару в подходящий матч и возвращает индекс
const ensurePair = (ms, a, b) => {
  const same = (m, x, y) =>
    (m.a === x && m.b === y) || (m.a === y && m.b === x);

  // 0) Если уже есть точное совпадение — просто вернуть индекс
  let idx = ms.findIndex(m => same(m, a, b));
  if (idx !== -1) return idx;

  // 1) Полностью пустой слот
  idx = ms.findIndex(m => (m.a === "—" && m.b === "—") || (!m.a && !m.b));
  if (idx !== -1) {
    const m = ms[idx] || {};
    ms[idx] = { ...m, a: a ?? "—", b: b ?? "—" };
    return idx;
  }

  // 2) Слот, где пусто хотя бы с одной стороны и нет полного совпадения
  idx = ms.findIndex(m =>
    ((m.a === "—" || !m.a) || (m.b === "—" || !m.b)) && !same(m, a, b)
  );
  if (idx !== -1) {
    const m = ms[idx] || {};
    ms[idx] = { ...m, a: m.a || a || "—", b: m.b || b || "—" };
    return idx;
  }

  // 3) Слот, где есть ОДИН из участников (не полное совпадение)
  idx = ms.findIndex(m =>
    ([m.a, m.b].includes(a) || [m.a, m.b].includes(b)) && !same(m, a, b)
  );
  if (idx !== -1) {
    const m = ms[idx] || {};
    ms[idx] = { ...m, a: m.a || a || "—", b: m.b || b || "—" };
    return idx;
  }

  // 4) Fallback — первая ячейка (не создавая дублей)
  idx = 0;
  const m = ms[idx] || {};
  if (!same(m, a, b)) {
    ms[idx] = { ...m, a: m.a || a || "—", b: m.b || b || "—" };
  }
  return idx;
};


if (finalFlag) {
   const fi = rounds.findIndex(r => labelIsFinal(r.label)); 
    if (fi === -1) return;
    const ms = rounds[fi].matches || [];
    const i = ensurePair(ms, winner, loser);              // ← гарантируем, что пара финала появится
    const m = ms[i];
    ms[i] = { ...m, winner, loser: inferLoser(m) };       // и сразу помечаем winner/loser
    return;
  }

  // Полуфиналы
  const si = rounds.findIndex(r => labelIsSemi(r.label));
  if (si === -1) return;
  const semis = rounds[si].matches;
  const i = ensurePair(semis, winner, loser);             // ← вписываем пару полуфинала, если её не было
  const m = semis[i];
  semis[i] = { ...m, winner, loser: inferLoser(m) };      // и помечаем исход
  putSemiWinnerToFinal(rounds, winner, i);
  // Если оба полуфинальных победителя известны — соберём финал
 const winners = semis.map(m => m.winner).filter(Boolean);
if (winners.length === 2) {
  setFinalPair(winners[0], winners[1]);
} else if (winners.length === 1) {
  // чтобы второй стол сразу увидел хотя бы одного финалиста
  ensureFinalSlot(winners[0]);
}
});

// хелперы для извлечения имён
const _p1 = o => o?.a ?? o?.player1 ?? o?.player1Name ?? o?.player1_name ?? null;
const _p2 = o => o?.b ?? o?.player2 ?? o?.player2Name ?? o?.player2_name ?? null;
const hasPair = o => !!(_p1(o) && _p2(o));

const setSemis = (src, A, B) => {
  console.group(`[SEMIS][set][${src}]`); console.log('A:', A, 'B:', B); console.groupEnd();

  const validA = hasPair(A);
  const validB = hasPair(B);

  // ⬇️ если сервер не прислал пары — НИЧЕГО не меняем (не затираем на "—")
  if (!validA && !validB) {
    console.log(`[SEMIS][${src}] empty snapshot → keep current`);
    return;
  }

  setSemisBothPairs(validA ? A : null, validB ? B : null);
};


// рядом с patchRounds(...)
const ensureFinalSlot = (name) => patchRounds(rounds => {
  const fi = rounds.findIndex(r => isFinal(r.label));
  if (fi === -1 || !name) return;
  const m = { ...(rounds[fi].matches?.[0] || {}) };

  // не дублируем
  if (![m.a, m.b].includes(name)) {
    if (!m.a || m.a === '—') m.a = name;
    else if (!m.b || m.b === '—') m.b = name;
  }
  rounds[fi].matches[0] = m;
});



const setSemisBothPairs = (A, B) => patchRounds(rounds => {
  const si = rounds.findIndex(r => isSemi(r.label));
  if (si === -1) return;

  const ms = rounds[si].matches || [{ a: "—", b: "—" }, { a: "—", b: "—" }];

  const apply = (idx, pair) => {
    if (!pair) return;                  // ничего не прислали — оставляем как было
    const a = _p1(pair);
    const b = _p2(pair);
    if (!a && !b) return;               // пустышка — игнор
    ms[idx] = { ...ms[idx], a: a ?? ms[idx].a ?? "—", b: b ?? ms[idx].b ?? "—" };
  };

  apply(0, A);
  apply(1, B);

  rounds[si].matches = ms;
});



// победитель полуфинала → в финал, без дублей
const putSemiWinnerToFinal = (rounds, winner, semiIndex /* 0 или 1 */) => {
  if (!winner) return;
  const fi = rounds.findIndex(r => labelIsFinal(r.label));
  if (fi === -1) return;

  const ms = rounds[fi].matches || (rounds[fi].matches = [{}]);
  const m  = ms[0] || (ms[0] = { a: '—', b: '—' });

  const slot  = semiIndex === 0 ? 'a' : 'b';
  const other = slot === 'a' ? 'b' : 'a';

  // если уже стоял в «другой» ячейке — убираем дубликат
  if (m[other] === winner) m[other] = '—';

  // ставим только в свою ячейку и только если она пустая
  if (!m[slot] || m[slot] === '—') m[slot] = winner;

  // финальная страховка от дубля: a == b → очищаем вторую
  if (m.a && m.b && m.a === m.b) m[other] = '—';
};





// === Полный перезаписыватель полуфиналов по снапшоту ===
const replaceSemisFromSnapshot = React.useCallback((semifinalTables = []) => {
  setBracketRounds(prev => {
    // делаем копию
    const next = prev.map(r => ({ ...r, matches: r.matches.map(m => ({ ...m })) }));
    // ищем раунд "Полуфиналы"
    const si = next.findIndex(r => isSemi(r.label));
    if (si === -1) return prev;

    // нормализация одной записи пары
    const norm = (t = {}) => ({
      a: t.player1Name ?? t.player1 ?? t.player1_name ?? '—',
      b: t.player2Name ?? t.player2 ?? t.player2_name ?? '—',
      winner: t.winner ?? undefined,
      loser:  t.loser  ?? undefined,
      status: t.status ?? undefined,
    });

    // жёстко перезаписываем обе ячейки полуфиналов
    const A = semifinalTables[0] || {};
    const B = semifinalTables[1] || {};
    next[si].matches = [norm(A), norm(B)];
    return next;
  });
}, []);



// alias чтобы не путаться с замыканием
const isFinalFn = (label) => isFinal(label);
useEffect(() => {
  // --- helpers ------------------------------------------------------
  const normPair = (p = {}) => ({
    tableId:  p.tableId ?? p.table_id ?? null,
    gameId:   p.gameId ?? p.game_id ?? null,
    player1:  p.player1 ?? p.player1Name ?? p.player1_name ?? null,
    player2:  p.player2 ?? p.player2Name ?? p.player2_name ?? null,
    status:   p.status ?? null,
  });

  const setSemis = (src, A, B) => {
    console.group(`[SEMIS][set][${src}]`);
    console.log('A:', A);
    console.log('B:', B);
    if (!A) console.warn('A отсутствует!');
    if (!B) console.warn('B отсутствует!');
    console.groupEnd();
    setSemisBothPairs(A || {}, B || {});
  };

  // --- listeners ----------------------------------------------------
  const onSemis = (payload = {}) => {
    console.group('[EV] tournament_semifinalsStarted');
    console.log('raw payload:', payload);

    const arr = Array.isArray(payload.semifinalTables) ? payload.semifinalTables : [];
    const top = payload.top || payload.semiTop || payload.semifinalTop || null;
    const bottom = payload.bottom || payload.semiBottom || payload.semifinalBottom || null;

    // приоритет: массив → top/bottom
    const A = arr[0] ? normPair(arr[0]) : (top ? normPair(top) : null);
    const B = arr[1] ? normPair(arr[1]) : (bottom ? normPair(bottom) : null);

    console.log('derived A from:', arr[0] ? 'semifinalTables[0]' : (top ? 'top' : 'none'));
    console.log('derived B from:', arr[1] ? 'semifinalTables[1]' : (bottom ? 'bottom' : 'none'));
    console.groupEnd();

    setSemis('semifinalsStarted', A, B);
  };

  const onAll = (list = []) => {
    console.group('[EV] responseAllTournaments');
    console.log('list.length =', list.length);
    const tid = String(tournamentId);
    const tTable = String(tournamentTableId);
    const playersOnTable = [tournamentPlayer1Name, tournamentPlayer2Name].filter(Boolean);

    let foundBy = 'none';
    const mine = list.find((t) => {
      const byId = String(t.id ?? t.tournamentId) === tid;
      const byTable = [t.semiTopTableId, t.semiBotTableId, t.finalTableId, t.semi_top_table_id, t.semi_bot_table_id, t.final_table_id]
        .some((x) => String(x) === tTable);

      const candidates = [
        t.semiTopP1, t.semiTopP2, t.semiBotP1, t.semiBotP2,
        t.finalP1,   t.finalP2,
        t.semi_top_p1, t.semi_top_p2, t.semi_bottom_p1, t.semi_bottom_p2
      ].filter(Boolean);

      const byPlayers = candidates.some((n) => playersOnTable.includes(n));

      if (byId) foundBy = 'id';
      else if (byTable) foundBy = 'tableId';
      else if (byPlayers) foundBy = 'players';

      return byId || byTable || byPlayers;
    });

    console.log('match by:', foundBy);
    if (!mine) {
      console.warn('mine not found for', { tournamentId, tournamentTableId, playersOnTable });
      console.groupEnd();
      return;
    }

    console.log('mine raw:', mine);

    const top = normPair({
      player1: mine.semiTopP1 ?? mine.semi_top_p1 ?? mine?.semifinalTop?.player1 ?? mine?.semifinal_top?.player1_name,
      player2: mine.semiTopP2 ?? mine.semi_top_p2 ?? mine?.semifinalTop?.player2 ?? mine?.semifinal_top?.player2_name,
    });

    // const bottom = normPair({
    //   player1: mine.semiBotP1 ?? mine.semi_bottom_p1 ?? mine?.semifinalBottom?.player1 ?? mine?.semifinal_bottom?.player2_name ? undefined : mine?.semifinal_bottom?.player1_name,
    //   // выше — страховка от странных схем; ниже — нормальный путь:
    //   player2: mine.semiBotP2 ?? mine.semi_bottom_p2 ?? mine?.semifinalBottom?.player2 ?? mine?.semifinal_bottom?.player2_name,
    // });
const bottom = normPair({
  player1: mine.semiBotP1 ?? mine.semi_bottom_p1
    ?? mine?.semifinalBottom?.player1
    ?? mine?.semifinal_bottom?.player1_name,
  player2: mine.semiBotP2 ?? mine.semi_bottom_p2
    ?? mine?.semifinalBottom?.player2
    ?? mine?.semifinal_bottom?.player2_name,
});

    console.log('derived top/bottom:', { top, bottom });
    console.groupEnd();

    setSemis('responseAllTournaments', top, bottom);


    // ▼ ДОБАВИТЬ: если сервер уже знает финалистов — зальём их в мини-брекет
  const f1 =
    mine.finalP1 ?? mine.final_p1 ??
    mine?.final?.player1 ?? mine?.finalTable?.player1 ?? null;

  const f2 =
    mine.finalP2 ?? mine.final_p2 ??
    mine?.final?.player2 ?? mine?.finalTable?.player2 ?? null;

  if (f1 || f2) {
    setFinalPair({ player1: f1 }, { player2: f2 });
  }

  };

  // const onFinal = (payload = {}) => {
  //   console.group('[EV] tournament_finalStarted');
  //   console.log('raw payload:', payload);
  //   const final = payload.finalTable || {
  //     player1: payload.finalP1,
  //     player2: payload.finalP2,
  //   };
  //   console.log('final normalized:', final);
  //   console.groupEnd();

  //   setFinalPair(final, final);
  // };
// было: setFinalPair(final, final);

const onFinal = (payload = {}) => {
  console.group('[EV] tournament_finalStarted');
  console.log('raw payload:', payload);

  // Нормализуем финалистов из разных полей
  const F = payload.finalTable || {
    player1: payload.finalP1 ?? payload.final_p1,
    player2: payload.finalP2 ?? payload.final_p2,
  };
  console.log('final normalized:', F);
  console.groupEnd();

  // ВАЖНО: передаём В РАЗНЫЕ аргументы
  const A = F?.player1 ? { player1: F.player1 } : null;
  const B = F?.player2 ? { player2: F.player2 } : null;

  if (A || B) {
    setFinalPair(A, B);      // заполнит a из A.player1 и b из B.player2
  }
};

  

  // Иногда полуснимок приходит через fetchTournamentData → tournamentDataResponse
  const onFetchData = (payload = {}) => {
    console.group('[EV] tournamentDataResponse');
    console.log('raw payload:', payload);

    const arr = Array.isArray(payload.semifinalTables) ? payload.semifinalTables : [];
    const A = arr[0] ? normPair(arr[0]) : null;
    const B = arr[1] ? normPair(arr[1]) : null;

    console.log('stage:', payload.tournamentStatus, 'semiCount:', arr.length);
    console.groupEnd();

    if (A || B) setSemis('tournamentDataResponse', A, B);
  };

  // --- subscribe ----------------------------------------------------
  tournamentSocket.on('tournament_semifinalsStarted', onSemis);
  tournamentSocket.on('responseAllTournaments', onAll);
  tournamentSocket.on('tournament_finalStarted', onFinal);
  tournamentSocket.on('tournamentDataResponse', onFetchData); // запасной канал снимка

  // --- unsubscribe --------------------------------------------------
  return () => {
    tournamentSocket.off('tournament_semifinalsStarted', onSemis);
    tournamentSocket.off('responseAllTournaments', onAll);
    tournamentSocket.off('tournament_finalStarted', onFinal);
    tournamentSocket.off('tournamentDataResponse', onFetchData);
  };
}, [
  tournamentId,
  tournamentTableId,
  tournamentPlayer1Name,
  tournamentPlayer2Name,
  tournamentSocket,
  setSemisBothPairs,
  setFinalPair,
]);


useEffect(() => {
  // Запрашиваем состояние всех турниров, чтобы показать обе полуфинальные пары
  if (!askedBracketRef.current && tournamentTableId && tournamentUsername) {
    askedBracketRef.current = true;
    tournamentSocket.emit('requestAllTournaments'); // сервер ответит 'responseAllTournaments'
  }
}, [tournamentTableId, tournamentUsername]);

// Записать участников полуфинала (в первый свободный слот или по индексу)
function upsertSemiPlayers(a, b, preferIndex = null) {
  setBracketRounds((prev) => {
    const rounds = prev.map(r => ({ ...r, matches: r.matches.map(m => ({ ...m })) }));
    const si = rounds.findIndex(r => isSemi(r.label));
    if (si === -1) return prev;
const ms = rounds[si].matches;
   const same = (m, x, y) => (m.a === x && m.b === y) || (m.a === y && m.b === x);
   const existIdx = ms.findIndex(m => same(m, a, b) || [m.a, m.b].includes(a) || [m.a, m.b].includes(b));
   if (existIdx !== -1) {
    //  const m = { ...ms[existIdx] };
    const m = { ...(ms[existIdx] || {}) };

     ms[existIdx] = { ...m, a: m.a || a || "—", b: m.b || b || "—" };
     return rounds; // не создаём дубль
   }
    const matchIdx =
      preferIndex ?? rounds[si].matches.findIndex(m => (m.a === "—" && m.b === "—") || (!m.a || !m.b));
    const idx = matchIdx === -1 ? 0 : matchIdx;

    const m = { ...(rounds[si].matches[idx] || {}) };
    m.a = a ?? m.a ?? "—";
    m.b = b ?? m.b ?? "—";
    // rounds[si].matches[idx] = m;
    ms[idx] = m;
    return rounds;
  });
}

// Проставить победителя в полуфинале и (если оба известны) автозалить имена в финал
function setSemiWinner(name) {
  setBracketRounds((prev) => {
    const rounds = prev.map(r => ({ ...r, matches: r.matches.map(m => ({ ...m })) }));
    const si = rounds.findIndex(r => isSemi(r.label));
    if (si === -1) return prev;

    const semis = rounds[si];
    const idx = semis.matches.findIndex(m => [m.a, m.b].includes(name));
    if (idx !== -1) semis.matches[idx].winner = name;

    const winners = semis.matches.map(m => m.winner).filter(Boolean);
    const fi = rounds.findIndex(r => isFinal(r.label));
    if (fi !== -1) {
      const f = { ...(rounds[fi].matches?.[0] || { a: "—", b: "—" }) };
      rounds[fi].matches[0] = { ...f, a: winners[0] || f.a, b: winners[1] || f.b };
    }
    return rounds;
  });
}

function setFinalPlayers(a, b) {
  setBracketRounds((prev) => {
    const rounds = prev.map(r => ({ ...r, matches: r.matches.map(m => ({ ...m })) }));
    const fi = rounds.findIndex(r => isFinal(r.label));
    if (fi === -1) return prev;
    const m = { ...(rounds[fi].matches?.[0] || {}) };
    rounds[fi].matches[0] = { ...m, a: a || m.a || "—", b: b || m.b || "—" };
    return rounds;
  });
}

function setFinalWinner(name) {
  setBracketRounds((prev) => {
    const rounds = prev.map(r => ({ ...r, matches: r.matches.map(m => ({ ...m })) }));
    const fi = rounds.findIndex(r => isFinal(r.label));
    if (fi === -1) return prev;
    const m = { ...(rounds[fi].matches?.[0] || {}) };
    // winner только если он совпадает с a или b
    if ([m.a, m.b].includes(name)) m.winner = name;
    rounds[fi].matches[0] = m;
    return rounds;
  });
}


 function tournamentDeepCopyBoard(board) {
  return board.map(point => point.map(checker => ({ ...checker })));
}







useEffect(() => {
  function handleTimeoutResult({ tableId, victory, message }) {
    console.log('[client] Получено tournament_timeoutResult:', { tableId, victory, message });

    // Показываем сообщение (можно заменить на свой компонент)
    setModalMessage(
      victory
        ? translate('jackpotBoard.opponentTimeout')
        : translate('jackpotBoard.ownTimeout')
    );
    setShowModal(true);
    setTimeout(() => {
      setShowModal(false);
      navigate('/');
    }, 300000);


    // if (!victory) {
    //   // Если проиграл — через 2 секунды уходим в лобби
    //   setTimeout(() => {
    //     navigate('/');
    //   }, 2000);
    // }
  }

  tournamentSocket.on('tournament_timeoutResult', handleTimeoutResult);

  return () => {
    tournamentSocket.off('tournament_timeoutResult', handleTimeoutResult);
  };
}, [navigate, translate]);


useEffect(() => {
  function handleTableClosed({ tableId }) {
    setModalMessage(translate('jackpotBoard.tableClosed'));
    setShowModal(true);

    setTimeout(() => {
      setShowModal(false);
      navigate('/');
    }, 300000);
  }

  tournamentSocket.on('tournament_tableClosed', handleTableClosed);
  return () => {
    tournamentSocket.off('tournament_tableClosed', handleTableClosed);
  };
}, [navigate, translate]);

// useEffect(() => {
//   function handleTableClosed({ tableId }) {
//   alert('Стол закрыт. Возвращаемся в лобби.');
//   setTimeout(() => navigate('/'), 2000);
// }

//   tournamentSocket.on('tournament_tableClosed', handleTableClosed);
//   return () => {
//     tournamentSocket.off('tournament_tableClosed', handleTableClosed);
//   };
// }, []);


const startTimerCountdown = ({ player1_time_left, player2_time_left, currentTurn }) => {
  clearInterval(intervalRef.current);

  setPlayer1Time(player1_time_left);
  setPlayer2Time(player2_time_left);
  currentTurnRef.current = currentTurn;

  intervalRef.current = setInterval(() => {
    if (currentTurnRef.current === 'player1') {
    setPlayer1Time(prev => Math.max(prev - 1, 0));
    } else {
      setPlayer2Time(prev => Math.max(prev - 1, 0));
    }
  }, 1000);
};


useEffect(() => {
  if (!tournamentCurrentTurn || !isMyTurnRef.current) return;

  startTimerCountdown({
    player1_time_left: player1Time,
    player2_time_left: player2Time,
    currentTurn: tournamentCurrentTurn,
  });
}, [tournamentCurrentTurn]);



useEffect(() => {
  return () => {
    clearInterval(intervalRef.current);
  };
}, []);


useEffect(() => {
  if (tournamentHasRolledDice) {
    hasAutoConfirmedRef.current = false;
  }
}, [tournamentHasRolledDice]);



useEffect(() => {
  const handler = (data) => {
    console.log('[Client] short_timerStarted:', data);
    const { player1_time_left, player2_time_left, currentTurn } = data;
    
    setPlayer1Time(player1_time_left);
    setPlayer2Time(player2_time_left);
    currentTurnRef.current = currentTurn;

    startTimerCountdown({
      player1_time_left,
      player2_time_left,
      currentTurn
    });
  };

  tournamentSocket.on('short_timerStarted', handler);

  return () => {
    tournamentSocket.off('short_timerStarted', handler);
  };
}, []);



useEffect(() => {
  console.log('Rolled Dice:', tournamentRolledDice);
  console.log('Has Rolled Dice:', tournamentHasRolledDice);
}, [tournamentRolledDice, tournamentHasRolledDice]);



useEffect(() => {
  console.log('DEBUG: tournamentCurrentTurn:', tournamentCurrentTurn);
  console.log('DEBUG: tournamentPlayerColor:', tournamentPlayerColor);
}, [tournamentCurrentTurn, tournamentPlayerColor]);



useEffect (()=>{
console.log('2837823',tournamentHasRolledDice);

},[tournamentHasRolledDice])



useEffect (()=>{
  console.log('5675757',tournamentRolledDice);
  
  },[tournamentRolledDice])


  useEffect (()=>{
    console.log('4321',tournamentCapturedCheckers);
    
    },[tournamentCapturedCheckers]) 

  
  




// const [tournamentBoard, setTournamentBoard] = useState(initialBoardSetup(playerColor, initialBoardState));
const [tournamentBoard, setTournamentBoard] = useState(Array(24).fill().map(() => []));



useEffect(() => {
  function handleBoardStateUpdated(data) {
    console.log('[client] "tournamentMatch_boardStateUpdated" received:', data);
    const {
      tableId: eventTableId,
      boardState,
      player,
      currentTurn,
      whiteOffBoard,
      blackOffBoard,
      updatedCapturedCheckers,
      numberMovePlayer1,
      numberMovePlayer2,
      player1Roll,
      player2Roll,
    } = data;

    // Если пришло обновление не для нашего стола => игнорируем
    if (String(eventTableId) !== String(tournamentTableId)) {
      return;
    }
    const localPlayer = (tournamentPlayerColor === 'white') ? 'player1' : 'player2';
    if (player === localPlayer) {
      console.log('[Tournament] boardStateUpdated: это наш ход => пропускаем обновление');
      return;
    }
    console.log('[Tournament] Получили boardStateUpdated от сервера:', data);

    // 1) boardState, capturedCheckers, offBoard
    //    Просто берём «как есть» и ставим в стейт:
    setTournamentBoard(() => [...boardState]); // создаём новую ссылку массива

    // Если updatedCapturedCheckers отсутствует, подставляем пустой объект
    setTournamentCapturedCheckers(updatedCapturedCheckers || { white: 0, black: 0 });

    // Обновляем массивы снятых шашек
    setTournamentWhiteOffBoard(whiteOffBoard || []);
    setTournamentBlackOffBoard(blackOffBoard || []);

    // 2) currentTurn и numberMove
    //    Если сервер говорит, что ход сменился, — пусть так и будет:
    if (currentTurn !== tournamentCurrentTurn) {
      console.log('[Tournament] Смена хода => currentTurn =', currentTurn);
      setTournamentCurrentTurn(currentTurn);

      // Опираясь на то, кто сейчас ходит, берём соответствующий numberMove
      if (currentTurn === 'player1') {
        setTournamentNumberMove(numberMovePlayer1 || 0);
      } else {
        setTournamentNumberMove(numberMovePlayer2 || 0);
      }

      // Сбрасываем/обновляем локальные броски?
      // Если по вашей логике сервер обнуляет hasRolledDice — обнуляем локально.
      setTournamentHasRolledDice(false);
    } else {
      // Ход НЕ сменился => можно (при желании) оставить локальный numberMove
      // или тоже поставить серверный, если хотите 100% синхрон
      // setTournamentNumberMove(...);
    }

    // 3) Если хотите видеть, какой дубль выпал оппоненту (player1Roll, player2Roll),
    //    можете что-то сделать с этими значениями, например:
    // if (player1Roll.length || player2Roll.length) {
    //   setTournamentRolledDice(...);
    // }

    // 4) Нет проверки "if (player === localPlayer) return;", 
    //    т.к. мы **всегда** берём серверное состояние как истину.
  }

  tournamentSocket.on('tournamentMatch_boardStateUpdated', handleBoardStateUpdated);

  return () => {
    tournamentSocket.off('tournamentMatch_boardStateUpdated', handleBoardStateUpdated);
  };
}, [
  tournamentTableId,
  tournamentCurrentTurn,
  // ... можно добавить tournamentBoard, tournamentPlayerColor и т.д. —
  // но обычно подписка достаточно один раз при монтировании компонента.
]);




const labelIsSemi  = (label) => String(label || tournamentStageLabel).toLowerCase().includes("полуфин");
const labelIsFinal = (label) => {
  const l = String(label || tournamentStageLabel).toLowerCase();
  return l.includes("финал") && !l.includes("полуфин");
};





const buildOutcomeMessage = useCallback(
  ({
    myName,
    winner,
    loser,
    isSemiFinal,
    isFinal,
    stage,
    round,
    reason
  }) => {
    const reasonText =
      reason === 'timeout'
        ? translate('jackpotBoard.reasonTimeoutSuffix')
        : reason === 'surrender'
        ? translate('jackpotBoard.reasonSurrenderSuffix')
        : '';

    // любой «признак финала» → финал
    const isFinalish =
      isFinal === true ||
      stage === 'final' ||
      round === 'final';

    if (myName === winner) {
      if (isFinalish) {
        return translate('jackpotBoard.shortChampion', { reason: reasonText });
      }
      if (isSemiFinal) {
        return translate('jackpotBoard.shortAdvanceFinal', { reason: reasonText });
      }
      return translate('jackpotBoard.shortAdvanceNext', { reason: reasonText });
    }

    if (myName === loser) {
      return isFinalish
        ? translate('jackpotBoard.shortRunnerUp', { winner, reason: reasonText })
        : translate('jackpotBoard.shortEliminated', { reason: reasonText });
    }

    // зрители/системные случаи
    return isFinalish
      ? translate('jackpotBoard.shortFinalChampion', { winner, reason: reasonText })
      : (winner
          ? translate('jackpotBoard.shortMatchWinner', { winner, reason: reasonText })
          : translate('jackpotBoard.shortMatchFinished'));
  },
  [translate]
);



const showOutcomeAndExit = useCallback((payload) => {
  const myName = localStorage.getItem('username');
  const msg = buildOutcomeMessage({ myName, ...payload });
  setModalMessage(msg);
  setShowModal(true);

  // Победитель полуфинала остаётся на странице — его переведёт ваш listener 'tournament_finalStarted'
  if (payload?.isSemiFinal && myName === payload?.winner) return;

  const delay = payload?.isFinal ? 300000 : 300000;
  setTimeout(() => {
    setShowModal(false);
    navigate('/');
  }, delay);
}, [buildOutcomeMessage, navigate, setModalMessage, setShowModal]);

function canMakeAnyMove(board, myColor, diceValues) {
  // 0) Если кубиков нет — нет ходов
if (
  !Array.isArray(board) ||
  board.length < 24 ||
  !Array.isArray(diceValues) ||
  diceValues.length === 0
) {
  console.warn(
    '[canMakeAnyMove] Некорректные данные:',
    {
      boardIsArray:
        Array.isArray(board),

      boardLength:
        Array.isArray(board)
          ? board.length
          : null,

      diceValues
    }
  );

  return false;
}

  // 1) Проходим по всем точкам доски
  for (let fromIndex = 0; fromIndex < 24; fromIndex++) {
    // Если в этой точке есть шашки нашего цвета
    const point =
  Array.isArray(board[fromIndex])
    ? board[fromIndex]
    : [];
    if (point.length > 0 && point[0].color === myColor) {
      // 2) Проверяем каждый кубик
      for (const die of diceValues) {
        // Для белых ход: targetIndex = fromIndex - die
        // Для чёрных:    targetIndex = fromIndex + die
        const targetIndex =
          (myColor === 'white')
            ? fromIndex - die
            : fromIndex + die;

        // Если вышли за границы — пропускаем
        if (targetIndex < 0 || targetIndex >= 24) {
          continue;
        }

        // Смотрим, что на целевой точке
        const targetPoint = board[targetIndex] || [];

        // Можно встать, если:
        //  - пункт пуст (length === 0),
        //  - там только наши шашки (каждый checker.color === myColor),
        //  - там ровно 1 чужая (для битья).
        const canPlace =
          targetPoint.length === 0 ||
          targetPoint.every(ch => ch.color === myColor) ||
          (targetPoint.length === 1 && targetPoint[0].color !== myColor);

        if (canPlace) {
          return true; // Нашли ход => сразу выходим
        }
      }
    }
  }

  // Если перебрали всё и не нашли ни одного допустимого хода
  return false;
}
useEffect(() => {
  if (
    !Array.isArray(tournamentRolledDice) ||
    tournamentRolledDice.length === 0 ||
    !Array.isArray(tournamentBoard) ||
    tournamentBoard.length < 24 ||
    !['white', 'black'].includes(tournamentPlayerColor)
  ) {
    return;
  }

  const possible = canMakeAnyMove(tournamentBoard, tournamentPlayerColor, tournamentRolledDice);

  const canBear = canBearOffAny(
       tournamentBoard,
       tournamentRolledDice,
       tournamentPlayerColor
     )



  // if (!possible) {
    if (!possible && !canBear) {
    // Ходов нет
    setTournamentNumberMove(0);
  } 
  
}, [tournamentRolledDice, tournamentBoard]);

  //////////////////////////////////////////////////////////////////////////
  //  Считываем userId из localStorage (если нужно)
  //////////////////////////////////////////////////////////////////////////
  useEffect(() => {
    const uid = parseInt(localStorage.getItem('userId'), 10);
    // console.log('[TournamentMatch] Мой userId:', uid);
    if (!Number.isNaN(uid)) {
      setTournamentMyUserId(uid);
    } else {
      console.warn('[TournamentMatch] userId не найден в localStorage');
    }
  }, []);

 


// console.log('[TournamentMatch] Состояние доски в начале:', tournamentBoard);
useEffect (()=>{
  
    console.log('7897979 Все ходы завершены. Завершаем ход автоматически.',tournamentNumberMove);
   
  
}, [tournamentNumberMove,]);




useEffect (()=>{
  
  console.log('5675665yhgh',tournamentBoard);
 

}, [tournamentBoard,]);
 
  const tournamentConfirmMove = useCallback(() => {
    console.log('834578');
    
    if (!tournamentTableId) {
      console.error('tournamentTableId не определен');
      return;
    }
  
    if (!tournamentCurrentTurn) {
      console.error('tournamentCurrentTurn не определен');
      return;
    }
  
    const boardStateString = JSON.stringify(tournamentBoard);
  

  
    if (!boardStateString) {
      console.error('tournamentBoard is undefined or empty');
      return;
    }
  const currentStateKey = JSON.stringify({
  boardState: boardStateString,
  capturedCheckers: tournamentCapturedCheckers,
  whiteOffBoard: tournamentWhiteOffBoard,
  blackOffBoard: tournamentBlackOffBoard,
  turn: tournamentCurrentTurn
});

if (lastSentStateRef.current === currentStateKey) {
  console.log('[Tournament] Повторный confirmMove — пропускаем.');
  return;
}

lastSentStateRef.current = currentStateKey;
    setTournamentMoveHistory([]);
    justConfirmedRef.current = true;

  // [FIX 2.1] — сразу блокируем клики, чтобы не было двойных действий:
  setDisableBoardClicks(true);

  // [FIX 2.2] — локально скрываем кнопку "Бросить кубики"
  setTournamentRollEnabled(false);






    // После отправки хода обновляем локальное состояние
    const nextTurn = tournamentCurrentTurn === 'player1' ? 'player2' : 'player1';
    setTournamentCurrentTurn(nextTurn);
    setTournamentFirstRollComplete(true);
    // setTournamentHasRolledDice(true); 
    setTournamentUsedRolls([]); // Сбрасываем использованные значения кубиков
    setTournamentRolledDice([]); // Сбрасываем использованные значения кубиков
    setTournamentFirstRolls({});
    
    setTournamentHasRolledDice(false)
    // console.log('[Tournament] Ход завершен, передан на сервер.');


  console.log('4654646',{
    tableId: tournamentTableId, // Используем tableId
    player: tournamentCurrentTurn,
    boardState: boardStateString,
    capturedCheckers: tournamentCapturedCheckers,
    whiteOffBoard: tournamentWhiteOffBoard,
    blackOffBoard: tournamentBlackOffBoard,
    tournamentFirstRollComplete: true
  });
   setTimeout(() => {
    // Отправляем событие confirmMove на сервер
    tournamentSocket.emit('tournamentMatch_confirmMove', {
      tableId: tournamentTableId, // Используем tableId
      player: tournamentCurrentTurn,
      boardState: boardStateString,
      capturedCheckers: tournamentCapturedCheckers,
      whiteOffBoard: tournamentWhiteOffBoard,
      blackOffBoard: tournamentBlackOffBoard,
      tournamentFirstRollComplete:true
    });
  hasAutoConfirmedRef.current = true;
}, 700);

  }, [
    tournamentTableId,
    tournamentCurrentTurn,
    tournamentBoard,
    tournamentCapturedCheckers,
    tournamentWhiteOffBoard,
    tournamentBlackOffBoard
  ]);

    
/** Сколько шашек данного цвета остаётся на поле 0‑23. */
function countOnBoard(board, color) {
  let cnt = 0;
  for (let i = 0; i < 24; i++) {
    if (board[i]?.length) {
      cnt += board[i].filter(ch => ch.color === color).length;
    }
  }
  return cnt;
}

/** Сколько шашек данного цвета ещё на баре. */
function countOnBar(captured, color) {
  return captured[color] || 0;
}

/**
 * Автоматически подтверждаем (и завершаем) ход, когда
 * у игрока больше нет шашек на поле  **ИЛИ**
 * он вынес все 15.
 */
useEffect(() => {
  // 1. Проверяем: мой ли ход?
  const myTurn =
    (tournamentPlayerColor === 'white' && tournamentCurrentTurn === 'player1') ||
    (tournamentPlayerColor === 'black' && tournamentCurrentTurn === 'player2');

  if (!myTurn) return;

  // 2. Проверяем: не отправляли ли уже confirm
  if (justConfirmedRef.current) return;

  // 3. Проверяем: доска должна быть НЕ пустой (иначе это F5 и ещё не восстановилась)
  const totalCheckers = tournamentBoard.reduce((sum, point) => sum + point.length, 0);
  const capturedWhite = tournamentCapturedCheckers?.white || 0;
  const capturedBlack = tournamentCapturedCheckers?.black || 0;
  const offWhite = tournamentWhiteOffBoard?.length || 0;
  const offBlack = tournamentBlackOffBoard?.length || 0;
  const totalAll = totalCheckers + capturedWhite + capturedBlack + offWhite + offBlack;

  if (totalAll === 0) {
    console.log('[AutoConfirm] Пропускаем — доска пуста (возможно F5)');
    return;
  }

  // 4. Считаем, сколько шашек осталось на поле и на баре
  const color = tournamentPlayerColor;
  const stillOnBoard = countOnBoard(tournamentBoard, color) + countOnBar(tournamentCapturedCheckers, color);

  // 5. Считаем, сколько вынесено
  const offCount = (color === 'white') ? tournamentWhiteOffBoard.length : tournamentBlackOffBoard.length;

  const victory = (stillOnBoard === 0) || (offCount === 15);

  if (victory) {
    justConfirmedRef.current = true;
    console.log('[AutoConfirm] Победа определена, отправляем confirmMove() через 30ms');
    setTimeout(() => tournamentConfirmMove(), 30);
  }
}, [
  tournamentBoard,
  tournamentCapturedCheckers,
  tournamentWhiteOffBoard,
  tournamentBlackOffBoard,
  tournamentCurrentTurn,
  tournamentPlayerColor
]);


  useEffect(() => {
    const handleTournamentConfirmed = (data) => {
      console.log('[Tournament] Подтверждено сервером:', data);
  
      const {
        tableId,
        boardState,
        newCurrentTurn,
        capturedCheckers,
        whiteOffBoard,
        blackOffBoard,
        hasRolledDice,
        numberMove,
        firstMoveComplete,
      } = data;
  
      // 1) Проверяем, что это именно наш стол
      if (String(tableId) !== String(tournamentTableId)) {
        console.warn('[Tournament] Получено событие не для нашего tableId:', tableId);
        return;
      }
  
      // 2) Разблокируем доску (если блокировали перед confirmMove)
      justConfirmedRef.current = false;
      setDisableBoardClicks(false);
  
      // 3) Обновляем состояние
      setTournamentBoard(JSON.parse(boardState));
      setTournamentCurrentTurn(newCurrentTurn);
      setTournamentCapturedCheckers(capturedCheckers || { white: 0, black: 0 });
      setTournamentHasRolledDice(false);
      setTournamentFirstRolls({});
      setTournamentRolledDice([]);
      setTournamentNumberMove(numberMove || 0);
      setTournamentFirstRollComplete(firstMoveComplete);
      setFirstMoveComplete(true);
  
      // 4) КТО теперь ходит?
      const myRole = (tournamentPlayerColor === 'white') ? 'player1' : 'player2';
      if (newCurrentTurn === myRole) {
        console.log('Наш ход, показать кнопку бросить кубики');
        
        // Это мой ход → показываем кнопку
        setRollButtonEnabled(true);
        setTournamentHasRolledDice(false);
      } else {
        // Ход оппонента → кнопку скрываем
        setRollButtonEnabled(false);
      }
    };
  
    tournamentSocket.on('tournamentMatch_confirmed', handleTournamentConfirmed);
  
    return () => {
      tournamentSocket.off('tournamentMatch_confirmed', handleTournamentConfirmed);
    };
  }, [
    tournamentBoard,
    tournamentPlayerColor, // чтобы при смене цвета корректно воспринимался myRole
  ]);
  
  

function canMakeAnyNormalMove(remainingRolls, board, playerColor) {
  // Проходим по всей доске
  for (let fromIndex = 0; fromIndex < board.length; fromIndex++) {
    const point = board[fromIndex];
    // Если в point лежат наши шашки
    if (point.length > 0 && point[0].color === playerColor) {
      // Для каждого броска check roll
      for (let roll of remainingRolls) {
        // Вычисляем targetIndex
        const targetIndex = (playerColor === 'white')
          ? fromIndex - roll
          : fromIndex + roll;

        // Если вышли за границы
        if (targetIndex < 0 || targetIndex >= board.length) continue;

        // Смотрим, что на целевой точке
        const targetPoint = board[targetIndex];
        // Условия: пусто, или все свои, или ровно 1 чужая (сбитие)
        if (
          !targetPoint || 
          targetPoint.length === 0 ||
          targetPoint.every(ch => ch.color === playerColor) ||
          (targetPoint.length === 1 && targetPoint[0].color !== playerColor)
        ) {
          // нашли хотя бы 1 ход => возвращаем true
          return true;
        }
      }
    }
  }
  // Если перебрали всё и не нашли ни одного варианта => false
  return false;
}








function tournamentCheckBarMoveAvailability(
  remainingRolls,
  board,
  capturedCheckers,
  playerColor
)



{
  console.log('[tournamentCheckBarMoveAvailability]', {
    remainingRolls,
    board,
    capturedCheckers,
    playerColor
  });
  // 1) Сколько шашек на баре у текущего игрока?
  const barCount = tournamentCapturedCheckers[playerColor] || 0;

  // Если на баре нет шашек => нет блока, возвращаем false
  if (barCount === 0) {
    return false; 
  }

  // 2) Вспомогательная функция: можно ли поставить ОДНУ шашку с бара, имея `roll`
  function canEnterWithRoll(roll) {
    const targetIndex = (playerColor === 'white')
      ? (24 - roll)
      : (roll - 1);

    // Выход за границы
    if (targetIndex < 0 || targetIndex >= 24) {
      return false;
    }

    const targetPoint = board[targetIndex] || [];
    // Пусто => можно
    if (targetPoint.length === 0) {
      return true;
    }
    // Все свои => можно
    if (targetPoint.every(ch => ch.color === playerColor)) {
      return true;
    }
    // Ровно 1 чужая => можно сбить
    if (targetPoint.length === 1 && targetPoint[0].color !== playerColor) {
      return true;
    }

    return false;
  }

  // 3) Проверяем, можем ли мы ввести ХОТЯ БЫ ОДНУ шашку
  //    (не пытаемся «скопом» ввести все barCount)
  for (let roll of remainingRolls) {
    if (canEnterWithRoll(roll)) {
      // Как только нашли один roll, который позволяет ввести ОДНУ шашку,
      // значит «не заблокировано», можно ходить
      return false; 
    }
  }

  // Если ни один roll не подошёл => «блок» (true)
  return true;
}



 
  const handleCheckerEntry = () => {
    
  };





  // helpers
const pick = (o, ...keys) => keys.reduce((acc, k) => acc ?? (o?.[k]), undefined);
const norm = v => (typeof v === 'string' ? v : undefined);
const p1 = o => norm(o) ?? pick(o, 'player1', 'player1_name', 'p1', 'P1', 'a', 'A');
const p2 = o => norm(o) ?? pick(o, 'player2', 'player2_name', 'p2', 'P2', 'b', 'B');









function tournamentOnCheckerClick(checkerIndex, checkerColor) {
  //////////////////////////////////////////////////
  // 1) Проверка условий хода
  //////////////////////////////////////////////////
  const isMyTurn =
    (tournamentCurrentTurn === (tournamentPlayerColor === 'white' ? 'player1' : 'player2'));

  if (!isMyTurn) return;

  // Кубики брошены?  (если !tournamentFirstRollComplete — значит это самый первый ход)
  if (!tournamentHasRolledDice && tournamentFirstRollComplete) {
    return;
  }

  if (tournamentNumberMove <= 0) {
    return;
  }

  // Смотрим, есть ли шашки на баре нашего цвета
  const barCount = tournamentCapturedCheckers[tournamentPlayerColor] || 0;
  if (barCount === 0) {
    return; // Нет шашек на баре => нечего «вводить»
  }

  // Помечаем, что ход сделан кликом (для Undo)
  setTournamentLastMoveType('click');


  //////////////////////////////////////////////////
  // 2) Собираем «оставшиеся» кубики (remainingRolls)
  //////////////////////////////////////////////////
  let remainingRolls;
  if (!tournamentFirstRollComplete && !firstMoveComplete) {
    // Самый первый ход (до confirm первого)
    const firstMoveRolls = [
      (tournamentPlayerColor === 'white')
        ? tournamentFirstRolls.player1Roll
        : tournamentFirstRolls.player2Roll,
      (tournamentPlayerColor === 'white')
        ? tournamentFirstRolls.player2Roll
        : tournamentFirstRolls.player1Roll,
    ];
    remainingRolls = firstMoveRolls.filter(r => !tournamentUsedRolls.includes(r));
  } else {
    // Обычный ход
    remainingRolls = tournamentRolledDice.filter(r => !tournamentUsedRolls.includes(r));
  }

  // Если дубль, расширяем до 4
  if (tournamentRolledDice[0] === tournamentRolledDice[1]) {
    const dieVal = tournamentRolledDice[0];
    const usedTimes = tournamentUsedRolls.filter(x => x === dieVal).length;
    const total = 4 - usedTimes;
    for (let i = 0; i < total; i++) {
      remainingRolls.push(dieVal);
    }
  }

  // Сортируем по убыванию (обычно удобнее)
  remainingRolls.sort((a, b) => b - a);


  //////////////////////////////////////////////////
  // 3) Готовим доску / захваченных для реального хода
  //////////////////////////////////////////////////
  // (!) Обратите внимание: если вы используете "simulateOneMove",
  //    можно здесь вызывать. Но ниже — «вручную»:
  const newBoard = tournamentDeepCopyBoard(tournamentBoard);
  const newCaptured = { ...tournamentCapturedCheckers };

  // fromIndex = 25 (бар) — универсальный для белых/чёрных
  const fromIndex = 25;
  let foundMove = false;
  let usedRollValue = null;
  let targetIndex = null;
  let capturedChecker = null;

  //////////////////////////////////////////////////
  // 4) Перебираем кубики: ищем «подходящий»
  //////////////////////////////////////////////////
  for (let dieVal of remainingRolls) {
    // Запрещаем «сливать» — если dieVal > 6, пропускаем
    if (dieVal < 1 || dieVal > 6) {
      continue; 
    }

    // Для белых: targetIndex = 24 - dieVal
    // Для чёрных: targetIndex = dieVal - 1
    if (tournamentPlayerColor === 'white') {
      targetIndex = 24 - dieVal;
    } else {
      targetIndex = dieVal - 1;
    }

    // Выход за границы
    if (targetIndex < 0 || targetIndex >= 24) {
      continue;
    }

    // Проверяем, нет ли 2+ чужих
    if (
      newBoard[targetIndex]?.length > 1 &&
      newBoard[targetIndex][0].color !== tournamentPlayerColor
    ) {
      continue;
    }

    // Есть ли у нас вообще шашка на баре?
    if (newCaptured[tournamentPlayerColor] <= 0) {
      // уже нет
      break;
    }

    // === Если дошли сюда => ход valid: снимаем с бара, сбиваем если надо, ставим
    newCaptured[tournamentPlayerColor]--;

    // Сбиваем чужую, если 1 враг
    if (
      newBoard[targetIndex]?.length === 1 &&
      newBoard[targetIndex][0].color !== tournamentPlayerColor
    ) {
      capturedChecker = newBoard[targetIndex].pop();
      const oppColor = capturedChecker.color;
      newCaptured[oppColor] = (newCaptured[oppColor] || 0) + 1;
    } else {
      capturedChecker = null;
    }

    // Кладём нашу
    const myChecker = { color: tournamentPlayerColor };
    newBoard[targetIndex] = newBoard[targetIndex] || [];
    newBoard[targetIndex].push(myChecker);

    foundMove = true;
    usedRollValue = dieVal;
    break; // прекращаем перебор
  }

  // Если не нашли подходящий кубик
  if (!foundMove) {
    // Можно обнулить ход:
    setTournamentNumberMove(0);
    return;
  }

  //////////////////////////////////////////////////
  // 5) Расходуем кубики + пишем в историю
  //////////////////////////////////////////////////
  // Считаем, потратили ли мы 1 или 2 кубика
  // (Условие: если usedRollValue == d1+d2 => 2)
  // Или более простой вариант: 
  //   - чаще всего "1" (один бросок)
  //   - если выпало [3,4], sum=7, 
  //     но вы запретили "сливать", значит usedRollValue=3 или 4
  // =>, значит movesUsed=1
  const [d1, d2] = tournamentRolledDice;
  const sumRoll = d1 + d2;
  let movesUsed = 1;
  let diceValuesUsed = [usedRollValue];

  // Если вдруг у вас логика "если usedRollValue === sumRoll, значит потратили оба"
  if (usedRollValue === sumRoll) {
    movesUsed = 2;
    diceValuesUsed = [d1, d2];
  }

  // Обновляем usedRolls, numberMove
  setTournamentUsedRolls(prev => [...prev, ...diceValuesUsed]);
  setTournamentNumberMove(prev => prev - movesUsed);

  // Запись хода в историю
  const currentNM = tournamentNumberMove;
  setTournamentMoveHistory(prev => [
    ...prev,
    {
      board: tournamentDeepCopyBoard(newBoard),
      from: 25, // «25» мы трактуем как бар
      to: targetIndex,
      checker: { color: tournamentPlayerColor },
      capturedChecker: capturedChecker,   // если сбили
      diceValuesUsed,
      numberMove: currentNM,
      updatedCapturedCheckers: { ...newCaptured },
    },
  ]);

  //////////////////////////////////////////////////
  // 6) Применяем новые стейты
  //////////////////////////////////////////////////
  setTournamentBoard(newBoard);
  setTournamentCapturedCheckers(newCaptured);

  // Если нужно для отображения последнего кубика
  // setTournamentLastMoveRoll(usedRollValue);
  setTournamentLastMoveType('click'); // уже стоит

  // Оповещаем оппонента
  tournamentSocket.emit('tournamentMatch_updateBoardState', {
    tableId: parseInt(tournamentTableId, 10),
    boardState: newBoard,
    updatedCapturedCheckers: newCaptured,
    player: (tournamentPlayerColor === 'white') ? 'player1' : 'player2',
    ephemeral: true,
  });
}

//     // Вызов handleCheckerEntry после успешного ввода шашки
    handleCheckerEntry();
  
  
  useEffect(() => {
    // 1) Если кубики не брошены — не проверяем
    if (!tournamentHasRolledDice) return;
  
    // 2) Считаем оставшиеся броски
    const remainingRolls = tournamentCalculateRemainingRolls(tournamentRolledDice, tournamentUsedRolls);
  

  }, [
    tournamentBoard,
    tournamentRolledDice,
    tournamentUsedRolls,
    tournamentHasRolledDice,
    tournamentCapturedCheckers
  ]);
  

  const tournamentHandleUndoMove = () => {
    console.log('123456');
    
    if (tournamentLastMoveType === 'click') {
      handleTournamentUndoMoveForClick();  // Если ход был сделан кликом
      
    } else if (tournamentLastMoveType === 'drag') {
      console.log('1234567');
      handleTournamentUndoMoveForDrag();   // Если ход был сделан перетаскиванием
    }
   
  };

  useEffect(() => {
    // Если сейчас мой ход, и я бросил кубики, и numberMove > 0, 
    // проверим, есть ли у меня шашки на баре и могу ли я их ввести.
    const isMyTurn =
      (tournamentCurrentTurn === 'player1' && tournamentPlayerColor === 'white')
      || (tournamentCurrentTurn === 'player2' && tournamentPlayerColor === 'black');

    if (isMyTurn && tournamentHasRolledDice && tournamentNumberMove > 0) {
      // Попробуем вызвать проверку
      // const noMoves = tournamentCheckBarMoveAvailability(
      //   tournamentRolledDice,       // remainingRolls - можно упростить
      //   tournamentBoard,
      //   tournamentCapturedCheckers
      // );
      // Если noMoves === true, значит показали кнопку или автоконфирм
    }
  }, [
    tournamentBoard,
    tournamentRolledDice,
    tournamentNumberMove,
    tournamentCapturedCheckers,
    tournamentHasRolledDice,
    tournamentPlayerColor,
    tournamentCurrentTurn,
    tournamentConfirmMove,
  ]);

  

  

function handleTournamentUndoMoveForDrag() {
  if (!tournamentMoveHistory.length) {
    console.log('[Undo-drag] Нет ходов для отмены');
    return;
  }

  // Берём последний ход
  const lastMove = tournamentMoveHistory[tournamentMoveHistory.length - 1];
  const {
    from,
    to,
    checker,
    capturedChecker,
    diceValuesUsed,
    board: boardAfter,      // снимок доски после хода
    updatedCapturedCheckers,
    numberMove
  } = lastMove;

  // Делаем копии текущих стейтов
  const newBoard = tournamentDeepCopyBoard(boardAfter);
  const newCaptured = { ...tournamentCapturedCheckers };
  let newWhiteOff = [...tournamentWhiteOffBoard];
  let newBlackOff = [...tournamentBlackOffBoard];

  // === (A) Случай Bear Off (to === 'off') ===
  if (to === 'off') {
    // Убираем шашку из offBoard
    let removedChecker = null;
    if (checker.color === 'white') {
      if (newWhiteOff.length > 0) {
        removedChecker = newWhiteOff.pop();
      }
    } else {
      if (newBlackOff.length > 0) {
        removedChecker = newBlackOff.pop();
      }
    }

    // Возвращаем снятую шашку на from
    if (removedChecker) {
      if (from === 25) {
        // С бара «на офф» (редкий случай): вернём обратно на бар
        newCaptured[removedChecker.color] =
          (newCaptured[removedChecker.color] || 0) + 1;
      } else {
        // Обычный индекс на доске
        if (!newBoard[from]) {
          newBoard[from] = [];
        }
        newBoard[from].push(removedChecker);
      }
    }

    // Применяем
    setTournamentWhiteOffBoard(newWhiteOff);
    setTournamentBlackOffBoard(newBlackOff);
    setTournamentBoard(newBoard);
    setTournamentCapturedCheckers(newCaptured);

    // Удаляем из истории
    setTournamentMoveHistory(prev => prev.slice(0, -1));
    setTournamentNumberMove(numberMove);

    // Откатываем usedRolls
    setTournamentUsedRolls(prev => {
      const arr = [...prev];
      if (diceValuesUsed) {
        diceValuesUsed.forEach(dVal => {
          const idx = arr.lastIndexOf(dVal);
          if (idx !== -1) arr.splice(idx, 1);
        });
      }
      return arr;
    });

    // Сообщаем оппоненту
    tournamentSocket.emit('tournamentMatch_undoMove', {
      tableId: parseInt(tournamentTableId, 10),
      newBoardState: newBoard,
      capturedCheckers: newCaptured,
      whiteOffBoard: newWhiteOff,
      blackOffBoard: newBlackOff,
      numberMove
    });

    return;
  }

  // === (B) Обычный ход (to — число) ===
  {
    // Снимаем нашу шашку с точки to
    let movedChecker = null;
    if (typeof to === 'number' && newBoard[to]?.length > 0) {
      movedChecker = newBoard[to].pop();
    } else {
      console.log('[Undo-drag] Не найдена шашка на точке to=', to);
      return;
    }

    // Если ход был с бара
    if (from === 25) {
      newCaptured[movedChecker.color] =
        (newCaptured[movedChecker.color] || 0) + 1;
    } else {
      // Иначе возвращаем на исходную точку
      if (!newBoard[from]) {
        newBoard[from] = [];
      }
      newBoard[from].push(movedChecker);
    }

    // Если была сбита чужая
    if (capturedChecker) {
      const oppColor = capturedChecker.color;
      newCaptured[oppColor] = Math.max(
        (newCaptured[oppColor] || 0) - 1,
        0
      );
      if (!newBoard[to]) {
        newBoard[to] = [];
      }
      newBoard[to].push(capturedChecker);
    }

    // Применяем
    setTournamentBoard(newBoard);
    setTournamentCapturedCheckers(newCaptured);
    setTournamentWhiteOffBoard(newWhiteOff);
    setTournamentBlackOffBoard(newBlackOff);

    setTournamentMoveHistory(prev => prev.slice(0, -1));
    setTournamentNumberMove(numberMove);

    // Откатываем usedRolls
    setTournamentUsedRolls(prev => {
      const arr = [...prev];
      if (diceValuesUsed) {
        diceValuesUsed.forEach(val => {
          const idx = arr.lastIndexOf(val);
          if (idx !== -1) arr.splice(idx, 1);
        });
      }
      return arr;
    });

    // Сообщаем оппоненту
    tournamentSocket.emit('tournamentMatch_undoMove', {
      tableId: parseInt(tournamentTableId, 10),
      newBoardState: newBoard,
      capturedCheckers: newCaptured,
      whiteOffBoard: newWhiteOff,
      blackOffBoard: newBlackOff,
      numberMove,
      player: (tournamentPlayerColor === 'white') ? 'player1' : 'player2'
    });
  }
}



function handleTournamentUndoMoveForClick() {
  




  if (tournamentMoveHistory.length === 0) {
    console.log('[Undo] Нет ходов для отмены!');
    return;
  }

  // 1) Берём последний ход из истории
  const lastMove = tournamentMoveHistory[tournamentMoveHistory.length - 1];
  console.log('[Undo] Отменяем ход (клик):', lastMove);

  const {
    from,
    to,
    checker,           // шашка, которую перемещали
    capturedChecker,   // если была сбита чужая
    diceValuesUsed,
    board: boardAfter, // снимок доски ПОСЛЕ хода
    numberMove,
  } = lastMove;

  // 2) Копируем состояние, чтобы откатить изменения
  //    "boardAfter" — это доска ПОСЛЕ сделанного хода
  const newBoard = tournamentDeepCopyBoard(boardAfter);

  // Делаем копию "captured", чтобы править локально
  // Если нужно подстраховаться, что поля точно есть:
  const newCaptured = {
    white: tournamentCapturedCheckers?.white || 0,
    black: tournamentCapturedCheckers?.black || 0,
  };

  // Копии off-boards
  let newWhiteOff = [...tournamentWhiteOffBoard];
  let newBlackOff = [...tournamentBlackOffBoard];

  // === (A) Если ход был Bear Off (to==='off') ===
  if (to === 'off') {
    let removedChecker = null;

    // A.1) Убираем шашку из whiteOffBoard / blackOffBoard
    if (checker.color === 'white') {
      if (newWhiteOff.length > 0) {
        removedChecker = newWhiteOff.pop();
      }
    } else {
      if (newBlackOff.length > 0) {
        removedChecker = newBlackOff.pop();
      }
    }

    // A.2) Если мы действительно сняли шашку, возвращаем её:
    //      - Если from===25 → на бар
    //      - Иначе на точку from
    if (removedChecker) {
      if (from === 25) {
        // "С бара на off" откатываем: значит возвращаем её снова на бар
        newCaptured[removedChecker.color] =
          (newCaptured[removedChecker.color] || 0) + 1;
      } else {
        // Обычная позиция 0..23
        if (!newBoard[from]) {
          newBoard[from] = [];
        }
        newBoard[from].push(removedChecker);
      }
    }

    // A.3) Теперь одним блоком записываем стейты
    setTournamentWhiteOffBoard(newWhiteOff);
    setTournamentBlackOffBoard(newBlackOff);
    setTournamentBoard(newBoard);
    setTournamentCapturedCheckers(newCaptured);

    // Убираем ход из истории
    setTournamentMoveHistory(prev => prev.slice(0, -1));
    setTournamentNumberMove(numberMove);

    // Откатываем usedRolls
    setTournamentUsedRolls(prev => {
      const arr = [...prev];
      if (diceValuesUsed) {
        diceValuesUsed.forEach(dVal => {
          const idx = arr.lastIndexOf(dVal);
          if (idx !== -1) arr.splice(idx, 1);
        });
      }
      return arr;
    });

    // Отправляем событие оппоненту
    tournamentSocket.emit('tournamentMatch_undoMove', {
      tableId: parseInt(tournamentTableId, 10),
      newBoardState: newBoard,
      capturedCheckers: newCaptured,
      whiteOffBoard: newWhiteOff,
      blackOffBoard: newBlackOff,
      numberMove,
      player: (tournamentPlayerColor === 'white') ? 'player1' : 'player2',
    });

    return;
  }

  // === (B) Обычный ход (или с бара), если to — число 0..23 ===
  {
    // B.1) Убираем нашу шашку с точки `to`
    if (!newBoard[to] || newBoard[to].length === 0) {
      console.log('[Undo] Не найдена шашка на точке to=', to);
      return;
    }
    const movedChecker = newBoard[to].pop();

    // B.2) Если ход был с бара (from===25), возвращаем снятую шашку обратно на бар
    if (from === 25) {
      newCaptured[movedChecker.color] =
        (newCaptured[movedChecker.color] || 0) + 1;
    } else {
      // Иначе возвращаем на исходную точку "from"
      if (!newBoard[from]) {
        newBoard[from] = [];
      }
      newBoard[from].push(movedChecker);
    }

    // B.3) Если была сбита чужая шашка
    if (capturedChecker) {
      const oppColor = capturedChecker.color;
      // Уменьшаем кол-во "захваченных" у оппонента
      newCaptured[oppColor] = Math.max(
        (newCaptured[oppColor] || 0) - 1,
        0
      );

      // Возвращаем эту шашку на точку `to`
      if (!newBoard[to]) {
        newBoard[to] = [];
      }
      newBoard[to].push(capturedChecker);
    }

    // B.4) Применяем итоговое состояние одним блоком
    setTournamentWhiteOffBoard(newWhiteOff);
    const localPlayer = (tournamentPlayerColor === 'white') ? 'player1' : 'player2';

    setTournamentBlackOffBoard(newBlackOff);
    setTournamentBoard(newBoard);
    setTournamentCapturedCheckers(newCaptured);

    setTournamentMoveHistory(prev => prev.slice(0, -1));
    setTournamentNumberMove(numberMove);

    // Откатываем usedRolls
    setTournamentUsedRolls(prev => {
      const arr = [...prev];
      if (diceValuesUsed) {
        diceValuesUsed.forEach(val => {
          const idx = arr.lastIndexOf(val);
          if (idx !== -1) arr.splice(idx, 1);
        });
      }
      return arr;
    });

    console.log('[Undo] Ход (кликом) отменён. Состояние восстановлено.');

    // Оповещаем оппонента
    tournamentSocket.emit('tournamentMatch_undoMove', {
      tableId: parseInt(tournamentTableId, 10),
      newBoardState: newBoard,
      capturedCheckers: newCaptured,
      whiteOffBoard: newWhiteOff,
      blackOffBoard: newBlackOff,
      numberMove,
      player: (tournamentPlayerColor === 'white') ? 'player1' : 'player2',
    });
  }
}



useEffect(() => {
  function handleMoveUndone(data) {
    console.log('[CLIENT:initiator?] "tournamentMatch_moveUndone" received => data=', data)
    const {
      tableId,
      newBoardState,
      capturedCheckers,
      numberMove,
      whiteOffBoard,
      blackOffBoard,

      // ВАЖНО: нужно, чтобы при undoMove
      // мы тоже получали поле 'player' (кто инициировал)
      // Иначе не сможем отличить "наш" undo от "чужого".
      player,
    } = data;

    // 1) Проверяем, что событие именно для нашего стола
    if (String(tableId) !== String(tournamentTableId)) {
      return;
    }

    // 2) Игнорируем, если это наше собственное undo
    //    (поскольку мы уже локально отменили).
    //    Для этого нам нужно знать, кто "player1"/"player2" 
    //    и совпадает ли с localPlayer.
    const localPlayer = (tournamentPlayerColor === 'white') ? 'player1' : 'player2';
    if (player === localPlayer) {
      console.log('[Tournament] Получили undo, но это наше же => игнорируем.');
      return;
    }

    // 3) Если это undo оппонента — применяем
    if (data.player === localPlayer) {
      console.log("Это наше обновление, игнорируем");
      return;
    }
    console.log("Это не наше обновление, не игнорируем");
    setTournamentBoard(newBoardState);
    setTournamentCapturedCheckers(capturedCheckers);
    setTournamentNumberMove(numberMove);
    setTournamentWhiteOffBoard(whiteOffBoard || []);
    setTournamentBlackOffBoard(blackOffBoard || []);

    console.log('[Tournament] Undo-ход оппонента => локально откатились.');
  }

  tournamentSocket.on('tournamentMatch_moveUndone', handleMoveUndone);

  return () => {
    tournamentSocket.off('tournamentMatch_moveUndone', handleMoveUndone);
  };
}, [
  tournamentTableId,
  tournamentPlayerColor,          // нужно, чтобы внутри сравнивать localPlayer
  setTournamentBoard,
  setTournamentCapturedCheckers,
  setTournamentNumberMove,
  setTournamentWhiteOffBoard,
  setTournamentBlackOffBoard,
]);


 useEffect(() => {
  const isMyTurn = tournamentCurrentTurn === (tournamentPlayerColor === 'white' ? 'player1' : 'player2');

  // Скрываем кнопку, если не ваш ход или нет ходов для отмены
  if (!isMyTurn ||  tournamentMoveHistory.length === 0   || !tournamentHasRolledDice) {
    console.log('92834093');
    
    setTournamentShowUndoButton(false);
  } else {
    
    // Показываем кнопку, если есть ходы для отмены
    setTournamentShowUndoButton(true);
  }

  
   }, [tournamentCurrentTurn, tournamentMoveHistory.length, tournamentPlayerColor,tournamentHasRolledDice]);

useEffect(() => {
  if (!autoRoll) return;

  const isMyTurn =
    (tournamentPlayerColor === 'white' && tournamentCurrentTurn === 'player1') ||
    (tournamentPlayerColor === 'black' && tournamentCurrentTurn === 'player2');

  if (isMyTurn && !tournamentHasRolledDice && rollButtonEnabled) {
    // используем уже готовую функцию
    handleTournamentRollDiceClick();
  }
}, [autoRoll, tournamentPlayerColor, tournamentCurrentTurn, tournamentHasRolledDice, rollButtonEnabled]);




useEffect(() => {
  if (!autoConfirm) return;

  const isMyTurn =
    (tournamentPlayerColor === 'white' && tournamentCurrentTurn === 'player1') ||
    (tournamentPlayerColor === 'black' && tournamentCurrentTurn === 'player2');

  // Если не наш ход, кубики не брошены, либо уже отправили автоход — выходим
  // if (!isMyTurn || !tournamentHasRolledDice || justConfirmedRef.current) {
  //   return;
  // }
  if (
    !isMyTurn ||
    !tournamentHasRolledDice ||
    !Array.isArray(tournamentRolledDice) ||
    tournamentRolledDice.length === 0 ||
    justConfirmedRef.current
  ) {
    return;
  }

  // --- НОВОЕ: проверка шашек на баре и входа с бара ---
  const myBarCount = tournamentCapturedCheckers?.[tournamentPlayerColor] || 0;

  if (myBarCount > 0) {
    // Считаем оставшиеся кубики с учётом дубля и уже использованных
    const remainingRolls = tournamentCalculateRemainingRolls(
      tournamentRolledDice,
      tournamentUsedRolls
    );

    let canEnterFromBar = false;

    for (const roll of remainingRolls) {
      // Для белых вход: 24 - roll (точки 23..18), для чёрных: roll - 1 (0..5)
      const targetIndex =
        tournamentPlayerColor === 'white'
          ? 24 - roll
          : roll - 1;

      if (targetIndex < 0 || targetIndex >= 24) continue;

      const targetPoint = tournamentBoard[targetIndex] || [];

      const isFreeForUs =
        targetPoint.length === 0 ||                                     // пусто
        targetPoint.every(ch => ch.color === tournamentPlayerColor) ||  // только наши
        (targetPoint.length === 1 && targetPoint[0].color !== tournamentPlayerColor); // одна чужая — можно сбить

      if (isFreeForUs) {
        canEnterFromBar = true;
        break;
      }
    }

    // ⚠️ Если есть хотя бы один ход с бара, НЕЛЬЗЯ автоматически передавать ход
    if (canEnterFromBar) {
      return;
    }
    // Если войти с бара нельзя вообще ни по одному кубику — это как раз "нет ходов",
    // и автоход можно делать (если ниже сработает условие).
  }

  // --- Старая логика: подтверждаем только когда ходов нет (numberMove === 0) ---
  if (tournamentNumberMove === 0) {
    justConfirmedRef.current = true;
    setTimeout(() => {
      tournamentConfirmMove();
    }, 700);
  }
}, [
  autoConfirm,
  tournamentPlayerColor,
  tournamentCurrentTurn,
  tournamentHasRolledDice,
  tournamentNumberMove,
  tournamentConfirmMove,
  tournamentCapturedCheckers,
  tournamentRolledDice,
  tournamentUsedRolls,
  tournamentBoard,
]);

// useEffect(() => {
//   if (!autoConfirm) return;

//   const isMyTurn =
//     (tournamentPlayerColor === 'white' && tournamentCurrentTurn === 'player1') ||
//     (tournamentPlayerColor === 'black' && tournamentCurrentTurn === 'player2');

//   // подтверждаем только когда уже бросили (иначе можно опередить бросок)
//   if (isMyTurn && tournamentHasRolledDice && tournamentNumberMove === 0 && !justConfirmedRef.current) {
//     justConfirmedRef.current = true; // чтобы не задвоить
//     setTimeout(() => {
//       tournamentConfirmMove();
//     }, 700);
//   }
// }, [autoConfirm, tournamentPlayerColor, tournamentCurrentTurn, tournamentHasRolledDice, tournamentNumberMove, tournamentConfirmMove]);


// Проверяет, можем ли мы "выбросить" (bear off) шашку с given fromIndex и значением roll
function canBearOffChecker(fromIndex, dieValue, board, playerColor) { 
  if (!allCheckersInHome(board, playerColor)) {
    return false;
  }
  if (playerColor === "white") {
    // целевой "индекс выхода" = -1, грубо говоря
    // 1) если (fromIndex+1 === dieValue) => можно
    if (fromIndex + 1 === dieValue) {
      return true;
    }
    // 2) если (dieValue > fromIndex+1) => можно, если fromIndex это самая дальняя (максимальная) занятая точка в доме
    if (dieValue > fromIndex + 1) {
      // ищем самую дальнюю (максимальный индекс) занятый в 0..5
      let maxOccupied = -1;
      for (let i = 0; i < 6; i++) {
        if (board[i]?.length && board[i][0].color === "white") {
          maxOccupied = Math.max(maxOccupied, i);
        }
      }
      // Если fromIndex = maxOccupied => ок
      return (fromIndex === maxOccupied);
    }
    return false;
  } else {
    // black
    // для чёрных "индекс выхода" = 24
    // 1) если (24 - fromIndex === dieValue) => можно
    if ((24 - fromIndex) === dieValue) {
      return true;
    }
    // 2) если (dieValue > 24 - fromIndex) => можно, если fromIndex это самая ближняя к выходу (минимальная) занятая точка в 18..23
    if (dieValue > (24 - fromIndex)) {
      let minOccupied = 999;
      for (let i = 23; i >= 18; i--) {
        if (board[i]?.length && board[i][0].color === "black") {
          minOccupied = Math.min(minOccupied, i);
        }
      }
      return (fromIndex === minOccupied);
    }
    return false;
  }
}

function allCheckersInHome(board, playerColor) {
  if (playerColor === "white") {
    for (let i = 6; i < 24; i++) {
      if (board[i]?.length && board[i][0].color === "white") {
        console.log("[allCheckersInHome] Нашли белую шашку за пределами дома. Возвращаем false.");
        return false;
      }
    }
    console.log("[allCheckersInHome] Не нашли белых за домом => true");
    return true;
  } else {
    // black
    for (let i = 0; i < 18; i++) {
      if (board[i]?.length && board[i][0].color === "black") {
        console.log("[allCheckersInHome] Нашли чёрную шашку за пределами дома. Возвращаем false.");
        return false;
      }
    }
    console.log("[allCheckersInHome] Не нашли чёрных за домом => true");
    return true;
  }
}


/**
 * Возвращает `true`, если при данных `board`, `diceValues` и `playerColor`
 * можно вывести хотя бы одну шашку (bear off).
 */
function canBearOffAny(board, diceArray, playerColor) {
  console.log('5959493',!allCheckersInHome(board, playerColor));
  
  // 1) Проверяем, что ВСЕ шашки playerColor в доме.
  if (!allCheckersInHome(board, playerColor)) {
    return false; // если не все шашки в доме — нет bear off
  }

  // 2) Ищем хотя бы одну шашку, которую реально можно вынести
  //    на каком-нибудь из кубиков (из diceArray).
  for (let fromIndex = 0; fromIndex < 24; fromIndex++) {
    if (!board[fromIndex].length) continue;
    if (board[fromIndex][0].color !== playerColor) continue;

    // Для каждой шашки посмотрим, можно ли её вынести
    for (let die of diceArray) {
      if (canBearOffChecker(fromIndex, die, board, playerColor)) {
        return true;
      }
    }
  }

  // Если ничего не подошло
  return false;
} 




// Функция для вычисления реального количества доступных ходов для обычного перемещения
// Функция для вычисления реального количества доступных ходов для обычного перемещения
function calculateRealMoves(tournamentBoard, tournamentPlayerColor, remainingDice) {
  let legalMovesCount = 0;
  // Для белых предполагаем, что перемещения идут от большего индекса к меньшему
  // Для чёрных – наоборот.
  for (let from = 0; from < tournamentBoard.length; from++) {
    if (tournamentBoard[from].length > 0 && tournamentBoard[from][0].color === tournamentPlayerColor) {
      for (let die of remainingDice) {
        let target;
        if (tournamentPlayerColor === 'white') {
          target = from - die;
        } else {
          target = from + die;
        }
        if (target < 0 || target >= tournamentBoard.length) continue;
        const targetPoint = tournamentBoard[target];
        if (!targetPoint || targetPoint.length === 0) {
          legalMovesCount++;
        } else if (targetPoint.every(ch => ch.color === tournamentPlayerColor)) {
          legalMovesCount++;
        } else if (targetPoint.length === 1 && targetPoint[0].color !== tournamentPlayerColor) {
          legalMovesCount++;
        }
      }
    }
  }
  return legalMovesCount;
}


  // ⬇️ НОВОЕ: обработчик нажатия "Сдаться"
 // в TournamentMatch.jsx
const handleTournamentSurrender = React.useCallback(() => {
  const isSure = window.confirm(translate('jackpotBoard.resignConfirmShort'));
  if (!isSure) return;

  tournamentSocket.emit('tournamentMatch_surrender', {
    tableId: parseInt(tournamentTableId, 10),
    player: (tournamentPlayerColor === 'white') ? 'player1' : 'player2',
    username: tournamentUsername
  });

  // критично: убираем привязку к текущему столу до редиректа
  localStorage.removeItem('tableId');

  setModalMessage(translate('jackpotBoard.surrenderReturn'));
  setShowModal(true);
  setTimeout(() => {
    setShowModal(false);
    navigate('/');
  }, 300000);
}, [tournamentTableId, tournamentPlayerColor, tournamentUsername, navigate, translate]);



// вынеси applySemiSnapshot, чтобы можно было переиспользовать
const applySemiSnapshot = useCallback((semifinalTables) => {
  const [A, B] = semifinalTables || [];
  const top = A ? {
    player1: A.player1Name ?? A.player1 ?? A.player1_name ?? null,
    player2: A.player2Name ?? A.player2 ?? A.player2_name ?? null,
  } : null;
  const bot = B ? {
    player1: B.player1Name ?? B.player1 ?? B.player1_name ?? null,
    player2: B.player2Name ?? B.player2 ?? B.player2_name ?? null,
  } : null;
  setSemisBothPairs(top, bot);
}, [setSemisBothPairs]);

// ➕ НОВЫЙ эффект: слушаем завершение матча любой пары (важно для второй пары)
useEffect(() => {
  function onGameFinished(payload) {
    console.log('33948483',payload);
    
    // сервер присылает: { isSemiFinal, semifinalTables, winner, loser, ... }
    if (!payload?.isSemiFinal) return;
    if (Array.isArray(payload.semifinalTables)) {
      applySemiSnapshot(payload.semifinalTables);
    }
    // если у тебя есть отдельный стейт для подсветки победителя — можно дернуть тут:
    // if (payload.winner && setSemisWinners) setSemisWinners(payload.winner, payload.loser);
  }
  tournamentSocket.on('tournamentMatch_gameFinished', onGameFinished);
  return () => tournamentSocket.off('tournamentMatch_gameFinished', onGameFinished);
}, [applySemiSnapshot]);


 
useEffect(() => {
  function applySemiSnapshot(semifinalTables) {
    const [A, B] = semifinalTables || [];

    // Нормализуем к полям player1/player2, чтобы подошло к твоей setSemisBothPairs
    const top = A ? {
      player1: A.player1Name ?? A.player1 ?? A.player1_name ?? null,
      player2: A.player2Name ?? A.player2 ?? A.player2_name ?? null,
    } : null;

    const bot = B ? {
      player1: B.player1Name ?? B.player1 ?? B.player1_name ?? null,
      player2: B.player2Name ?? B.player2 ?? B.player2_name ?? null,
    } : null;

    // Обновляем твою локальную мини-сетку через существующий хелпер
    setSemisBothPairs(top, bot);
  }

function onSemisSnapshot({ tournamentId: evTid, semifinalTables }) {
    if (evTid != null && tournamentId != null && String(evTid) !== String(tournamentId)) return;
    replaceSemisFromSnapshot(semifinalTables);
  }

  function onSemisStarted({ tournamentId: evTid, semifinalTables }) {
    if (evTid != null && tournamentId != null && String(evTid) !== String(tournamentId)) return;
    replaceSemisFromSnapshot(semifinalTables);
  }

  tournamentSocket.on('tournament_semifinalsSnapshot', onSemisSnapshot);
  tournamentSocket.on('tournament_semifinalsStarted', onSemisStarted);

  return () => {
    tournamentSocket.off('tournament_semifinalsSnapshot', onSemisSnapshot);
    tournamentSocket.off('tournament_semifinalsStarted', onSemisStarted);
  };
}, [tournamentId, setSemisBothPairs]);



useEffect(() => {
  function onPlayerSurrendered({ tournamentId: evTid, winner, loser, isFinal: isFinalFromServer, stageLabel }) {
  // Игнорируем ТОЛЬКО если оба id известны и они разные
  if (evTid != null && tournamentId != null && String(evTid) !== String(tournamentId)) {
    return;
  }

  const finalFlag = (isFinalFromServer != null)
    ? !!isFinalFromServer
    : labelIsFinal(stageLabel || tournamentStageLabel);

  applyMatchResult({ winner, loser, isFinal: finalFlag });
  tournamentSocket.emit('requestAllTournaments');

  if ([winner, loser].includes(tournamentUsername)) {
    localStorage.removeItem('tableId');
    setModalMessage(
      loser === tournamentUsername
        ? translate('jackpotBoard.youResigned')
        : translate('jackpotBoard.playerResignedWinner', { loser, winner })
    );
    setShowModal(true);
    setTimeout(() => { setShowModal(false); navigate('/'); }, 300000);
  }
}



  tournamentSocket.on('tournamentMatch_playerSurrendered', onPlayerSurrendered);
  return () => tournamentSocket.off('tournamentMatch_playerSurrendered', onPlayerSurrendered);
}, [tournamentId, tournamentStageLabel, tournamentUsername, navigate, translate]);







useEffect(() => {
  if (!tournamentHasRolledDice) return;
  
  const remainingDice = tournamentCalculateRemainingRolls();
  const legalMoves = calculateRealMoves(tournamentBoard, tournamentPlayerColor, remainingDice);
  
  console.log("calculateRealMoves: legalMoves =", legalMoves, "remainingDice =", remainingDice);
  
  // Если число реально доступных ходов меньше, чем текущий tournamentNumberMove, обновляем его.
  if (legalMoves < tournamentNumberMove) {
    // setTournamentNumberMove(legalMoves);
    console.log("[Tournament] Обновляем количество ходов до", legalMoves);
    // Если ходов нет (legalMoves === 0), вместо автоматического завершения просто отображаем кнопку.
    // Например, если у вас кнопка рендерится при tournamentNumberMove === 0,
    // то она появится автоматически.
  }
}, [tournamentHasRolledDice, tournamentBoard, tournamentUsedRolls, tournamentPlayerColor]);



// Для конкретного чекера, расположенного на fromIndex, вычисляем, сколько вариантов из массива dice возможны
function calculateMovesForChecker(board, fromIndex, playerColor, dice) {
  let count = 0;
  for (let d of dice) {
    let target;
    if (playerColor === 'white') {
      target = fromIndex - d;
    } else {
      target = fromIndex + d;
    }
    // Если target выходит за пределы доски – ход невозможен
    if (target < 0 || target >= board.length) continue;
    const targetPoint = board[target];
    // Если пункт пуст или заполнен своими шашками
    if (!targetPoint || targetPoint.length === 0 || targetPoint.every(ch => ch.color === playerColor)) {
      count++;
    }
    // Или если в пункте ровно одна шашка противника (можно сбить)
    else if (targetPoint.length === 1 && targetPoint[0].color !== playerColor) {
      count++;
    }
  }
  return count;
}



useEffect(() => {
  // Если кубики ещё не брошены или мы уже начали ход (есть хотя бы один ход в истории),
  // не пересчитываем число ходов.
  if (!tournamentHasRolledDice || !initialRollPhase || tournamentMoveHistory.length > 0) return;
  
  // Берём оставшиеся броски – если дубль, то расширяем до 4 копий
  let dice = tournamentRolledDice;
  if (dice[0] === dice[1]) {
    dice = Array(4).fill(dice[0]);
  }
  
}, [tournamentHasRolledDice, tournamentRolledDice, tournamentBoard, tournamentPlayerColor, initialRollPhase, tournamentMoveHistory]);






function handleBearOff(
  fromIndex,
  rollValue,
  board,
  playerColor,
  whiteOffBoard,
  blackOffBoard,
  setWhiteOffBoard,
  setBlackOffBoard
) {
  // Копируем доску
  const newBoard = tournamentDeepCopyBoard(board);

  // Забираем шашку
  const checker = newBoard[fromIndex].pop();

  // Кладём её в whiteOffBoard / blackOffBoard
  if (playerColor === 'white') {
    const updatedWhiteOff = [...whiteOffBoard, checker];
    setWhiteOffBoard(updatedWhiteOff);
  } else {
    const updatedBlackOff = [...blackOffBoard, checker];
    setBlackOffBoard(updatedBlackOff);
  }

  return { newBoard, checker }; // возвращаем и доску, и вынутую шашку
} 




useEffect(() => {
  function handleFinalStarted(data) {
    const { finalTableId, finalGameId, player1, player2 } = data;
    console.log('[client] финал создан =>', data);

    // Если currentUser = player1 || player2 => редирект
    const currentUser = localStorage.getItem('username');
    if (currentUser === player1 || currentUser === player2) {
      window.location.href = `/tournamentMatch/${finalGameId}?tableId=${finalTableId}`;
    } else {
      // alert('Начался финал! Можно наблюдать...');
    }
  }

  // function handleTournamentCompleted(data) {
  //   const { winner, message } = data;
  //   alert(`${message} Победитель: ${winner}`);
  // }
function handleTournamentCompleted({ winner, reason }) {
  const myName = localStorage.getItem('username');
    // СНАЧАЛА ставим результат в брекет (он же и пару создаст при необходимости)
 
  setLastOutcome({ winner, loser: null, isFinal: true, reason });
  setFinalWinner(winner); // <- добавили
 

  const msg = buildOutcomeMessage({
    myName,
    winner,
    loser: null,
    isSemiFinal: false,
    isFinal: true,
    reason
  });
  setModalMessage(msg);
  setShowModal(true);
  setTimeout(() => { setShowModal(false); navigate('/'); }, 300000);
}

 
  //   function handleTournamentCompleted({ winner, reason }) {
  //   const myName = localStorage.getItem('username');
  //     setLastOutcome({ winner, loser: null, isFinal: true, reason });
  //   const msg = buildOutcomeMessage({
  //     myName,
  //     winner,
  //     loser: null,
  //     isSemiFinal: false,
  //     isFinal: true,      // это точно финал
  //     reason
  //   });
  //   setModalMessage(msg);
  //   setShowModal(true);
  //   setTimeout(() => {
  //     setShowModal(false);
  //     navigate('/');
  //   }, myName === winner ? 10000 : 10000);
  // }

  // function handleTournamentCompleted({ winner }) {
  //   const myName = localStorage.getItem('username');
  //   const isMe = myName === winner;
  //   const msg = isMe
  //     ? 'Поздравляем! Вы — чемпион турнира! 🏆'
  //     : `Турнир завершён. Чемпион: ${winner}.`;

  //   setModalMessage(msg);
  //   setShowModal(true);
  //   setTimeout(() => {
  //     setShowModal(false);
  //     navigate('/'); 
  //   }, isMe ? 4000 : 2500);
  // }
  
  tournamentSocket.on('tournament_finalStarted', handleFinalStarted);
  tournamentSocket.on('tournament_completed', handleTournamentCompleted);

  return () => {
    tournamentSocket.off('tournament_finalStarted', handleFinalStarted);
    tournamentSocket.off('tournament_completed', handleTournamentCompleted);
  };
}, []);





useEffect(() => {
  // function fetchTournamentData() {
  //   // if (tournamentSocket.connected) {
  //   //   tournamentSocket.emit("fetchTournamentData", tournamentTableId);
  //   // } else {
  //   //   const handleConnect = () => {
  //   //     tournamentSocket.emit("fetchTournamentData", tournamentTableId);
  //   //   };
  //   //   tournamentSocket.on("connect", handleConnect);
  //   //   return () => {
  //   //     tournamentSocket.off("connect", handleConnect);
  //   //   };
  //   // }
  //     tournamentSocket.emit("fetchTournamentData", tournamentTableId);

  // }

  
  function handleTournamentDataResponse(data) {
    console.log('[client] "tournamentDataResponse" =>', data);
    if (!data) {
      console.log("[TournamentMatch] Нет данных (data пустое).");
      return;
    }
  
    // 1) Проверяем, не для другого ли стола данные
    if (String(data.table_id) !== String(tournamentTableId)) {
      console.warn("[TournamentMatch] Данные не для нашего стола:", data.table_id);
      return;
    }
  
      // ⬇️ ВОТ ЭТО ДОБАВЬ
  if (data.table_id != null) {
    try {
      localStorage.setItem('tournamentTableId', String(data.table_id));
    } catch (e) {
      console.warn('[TournamentMatch] не удалось сохранить tournamentTableId в localStorage', e);
    }
  }
  

     if (data.tournamentStageLabel || data.stageLabel) {
    setTournamentStageLabel(data.tournamentStageLabel ?? data.stageLabel ?? '');
  }
  if (data.tournamentId != null) {
    setTournamentId(Number(data.tournamentId));
  }

    // участники текущего матча
  const p1 = data.player1_name || null;
  const p2 = data.player2_name || null;

  // определить стадия/куда писать
  if (isSemi(data.tournamentStageLabel || data.stageLabel)) {
    upsertSemiPlayers(p1, p2);
  } else if (isFinal(data.tournamentStageLabel || data.stageLabel)) {
    setFinalPlayers(p1, p2);
  }



 // 3) Если (serverBoard == локальный board) — нет смысла применять:
 const isBoardSame = JSON.stringify(data.board_state) === JSON.stringify(tournamentBoard);
 if (isBoardSame) {
   console.log("[TournamentMatch] board_state совпадает с локальным => не перезаписываем.");
 } else {
   // 4) Доп. проверка: если у нас уже есть локальный confirmMove (например, только что передали ход),
   //    и сервер вернул старую версию => можем пропустить:
   //    Для этого нужен некий флаг, напр. "justConfirmed" (или "pendingConfirm"), выставляемый в confirmMove. 
  //  if (justConfirmedRef.current) {
  //    console.log("[TournamentMatch] Только что подтвердили ход => возможно сервер шлёт старое состояние => пропускаем.");
  //    // Либо пропускаем, либо сравниваем updatedAt, можно подробнее сделать.
  //    return;
  //  }
   
   // Иначе реально применяем serverBoard
   console.log("[TournamentMatch] Применяем board_state из data => локально обновляем.");
   setTournamentBoard(data.board_state || []);
 }




    console.log("[TournamentMatch] Получены данные турнира:", data);
    setTournamentLoading(false);
  
    // 2) firstMoveComplete (если нужно)
    // setFirstMoveComplete(data.firstMoveComplete || false);
    // setTournamentFirstRollComplete(data.firstMoveComplete || false);
  
const serverFirstRollComplete =
  Boolean(data.firstRollComplete);

const serverFirstMoveComplete =
  Boolean(data.firstMoveComplete);

setTournamentFirstRollComplete(
  serverFirstRollComplete
);

setFirstMoveComplete(
  serverFirstMoveComplete
);

    // аватар/рейтинг с сервера
setPlayer1Avatar(data.player1_avatar ?? null);
setPlayer2Avatar(data.player2_avatar ?? null);
setPlayer1ShortRating(
  typeof data.player1_short_rating === 'number' ? data.player1_short_rating : 1200
);
setPlayer2ShortRating(
  typeof data.player2_short_rating === 'number' ? data.player2_short_rating : 1200
);


const openingPlayer1Die =
  getTournamentOpeningDie(
    data.player1_rolls
  );

const openingPlayer2Die =
  getTournamentOpeningDie(
    data.player2_rolls
  );

if (
  openingPlayer1Die !== null &&
  openingPlayer2Die !== null
) {
  setTournamentFirstRolls({
    player1Roll: openingPlayer1Die,
    player2Roll: openingPlayer2Die
  });
}
    // if (!data.firstMoveComplete) {
    //   const firstRolls = {
    //     player1Roll: data.player1_rolls?.[0] || [],
    //     player2Roll: data.player2_rolls?.[0] || [],
    //   };
    //   setTournamentFirstRolls(firstRolls);
    //   console.log("[TournamentMatch] Первый ход ещё не завершён. firstRolls =", firstRolls);
    // }
  
    // 3) Обновляем доску, captured, тек.ход
    setTournamentBoard(data.board_state || []);
    setTournamentCapturedCheckers(data.captured_checkers || { white: 0, black: 0 });
    setTournamentWhiteOffBoard(data.white_off_board);
    setTournamentBlackOffBoard(data.black_off_board);
    // 4) Смотрим, какой был ход до этого, чтобы понять, сменился ли
    const previousTurn = tournamentCurrentTurn; 
    setTournamentCurrentTurn(data.current_turn || null);
  
    setTournamentPlayer1Name(data.player1_name || null);
    setTournamentPlayer2Name(data.player2_name || null);
  
    // 5) Определяем мой цвет
    const myUsername = localStorage.getItem("username") || "";
    let myColor = (data.player1_name === myUsername) ? 'white' : 'black';
    setTournamentPlayerColor(myColor);
    setTournamentOpponentColor(myColor === 'white' ? 'black' : 'white');
  
   /*
 * Цвет текущего пользователя уже определён выше:
 *
 * myColor === 'white' или 'black'
 */
const myRole =
  myColor === 'white'
    ? 'player1'
    : 'player2';

const serverCurrentTurn =
  data.current_turn || null;

setTournamentCurrentTurn(
  serverCurrentTurn
);


/*
 * Берём последние нормализованные броски.
 *
 * Для [4] результат будет [4], а не число 4.
 * Для [[6, 3]] результат будет [6, 3].
 */
const lastRollPlayer1 =
  normalizeTournamentDice(
    data.player1_rolls
  );

const lastRollPlayer2 =
  normalizeTournamentDice(
    data.player2_rolls
  );


/*
 * До завершения первого игрового хода
 * победитель использует два стартовых кубика:
 * один кубик player1 и один кубик player2.
 */
const openingMoveInProgress =
  serverFirstRollComplete &&
  !serverFirstMoveComplete;

const openingDice = [
  openingPlayer1Die,
  openingPlayer2Die
].filter(
  (die) =>
    Number.isInteger(die) &&
    die >= 1 &&
    die <= 6
);


/*
 * Проверяем бросок того игрока,
 * который сейчас ходит.
 */
const currentTurnHasRolled =
  serverCurrentTurn === 'player1'
    ? Boolean(data.hasRolledDicePlayer1)
    : serverCurrentTurn === 'player2'
      ? Boolean(data.hasRolledDicePlayer2)
      : false;


/*
 * Определяем кубики текущего хода.
 */
let currentTurnDice = [];

if (openingMoveInProgress) {
  currentTurnDice = openingDice;
} else if (serverCurrentTurn === 'player1') {
  currentTurnDice = lastRollPlayer1;
} else if (serverCurrentTurn === 'player2') {
  currentTurnDice = lastRollPlayer2;
}


/*
 * tournamentHasRolledDice в этом компоненте
 * фактически означает:
 *
 * "у игрока, который сейчас ходит, есть кубики".
 */
setTournamentHasRolledDice(
  openingMoveInProgress
    ? currentTurnDice.length === 2
    : currentTurnHasRolled
);


if (
  openingMoveInProgress ||
  currentTurnHasRolled
) {
  setTournamentRolledDice(
    currentTurnDice
  );
} else {
  setTournamentRolledDice([]);
}


/*
 * После F5 сервер является источником истины.
 * Поэтому число оставшихся ходов ставим напрямую.
 */
const movesLeftServer =
  serverCurrentTurn === 'player1'
    ? Number(data.numberMovePlayer1 ?? 0)
    : serverCurrentTurn === 'player2'
      ? Number(data.numberMovePlayer2 ?? 0)
      : 0;

setTournamentNumberMove(
  movesLeftServer
);


/*
 * Кнопка броска нужна только текущему игроку,
 * когда стартовый игровой ход уже завершён
 * и новых кубиков ещё нет.
 */
const itsMyTurn =
  serverCurrentTurn === myRole;

const canRollDice =
  itsMyTurn &&
  serverFirstMoveComplete &&
  !currentTurnHasRolled;

setTournamentRollEnabled(
  canRollDice
);


console.log(
  '[TournamentMatch] Состояние восстановлено:',
  {
    serverCurrentTurn,
    myRole,
    openingMoveInProgress,
    openingDice,
    currentTurnDice,
    movesLeftServer,
    currentTurnHasRolled,
    serverFirstRollComplete,
    serverFirstMoveComplete
  }
);
  
    console.log("[TournamentMatch] canRollDice =", canRollDice);
  }
  
  // Вызовем fetchTournamentData при монтировании
  //  fetchTournamentData();
  tournamentSocket.on("tournamentDataResponse", handleTournamentDataResponse);

  return () => {
    tournamentSocket.off("tournamentDataResponse", handleTournamentDataResponse);
  };
}, [tournamentTableId]); 




function computeRealNumberOfMoves(board, captured, offBoard, playerColor, d1, d2) {

  console.log(`[computeRealNumberOfMoves] START for ${playerColor}, dice=(${d1},${d2})`);
  // 1) Если дубль => считаем до 4
  if (d1 === d2) {
    const movesUsed = computeFourMovesWithBarAndBearOff(
      board, captured, offBoard, playerColor, d1
    );
    console.log(`[computeRealNumberOfMoves] It's a double! => movesUsed=${movesUsed}`);
    return movesUsed;
  }
  // 2) Иначе (d1 != d2) — пробуем 2 хода
  //    (а) checkTwoMovesPossible с (d1,d2)
  const can2 = checkTwoMovesPossible(board, captured, offBoard, playerColor, d1, d2);
 
  if (can2) {
     console.log(`[computeRealNumberOfMoves] can2=true => returning 2`)    
  return 2;
  }
  // (b) Если 2 не получается, проверяем, есть ли 1
  const can1 = checkSingleMovePossible(board, captured, offBoard, playerColor, d1, d2);
  console.log('234234');
  if (can1){
  console.log(`[computeRealNumberOfMoves] can1=true => returning 1`);
  return 1;
  }
  // (c) Иначе 0
  console.log(`[computeRealNumberOfMoves] No moves => returning 0`);
  return 0;
}

function computeFourMovesWithBarAndBearOff(board, captured, offBoard, playerColor, dieValue) {
  console.log('234234');
  
  // Делать 4 раза «simulateOneMoveWithBarAndBearOff»,
  // увеличивая счётчик, если получилось.

  let usedCount = 0;

  // Копии начальные
  let tempBoard = deepCopyBoard(board);
  let tempCaptured = { ...captured };
  let tempOffBoard = JSON.parse(JSON.stringify(offBoard));

  for (let i = 0; i < 4; i++) {
    const result = simulateOneMoveWithBarAndBearOff(
      tempBoard,
      tempCaptured,
      tempOffBoard,
      dieValue,
      playerColor
    );
    if (result) {
      usedCount++;
      // Обновляем текущие "temp" для следующего цикла
      tempBoard = result.boardAfter;
      tempCaptured = result.capturedAfter;
      tempOffBoard = result.offBoardAfter;
    } else {
      // если ход не удался, пропускаем его (по классике нард)
      // ничего не делаем, просто следующая итерация
    }
  }

  return usedCount; // от 0 до 4
}




  useEffect(() => {
    function handleDiceRolled(data) {
      // 1) Проверка, что это наш стол
      if (data.tableId !== parseInt(tournamentTableId, 10)) return;

      // 2) Определяем мой цвет
      const myColor = (localStorage.getItem("username") === data.player1_name)
        ? "white"
        : "black";

      // 3) Извлекаем последний бросок
      const lastRoll = (data.currentPlayer === "player1")
        ? data.player1_rolls[data.player1_rolls.length - 1]
        : data.player2_rolls[data.player2_rolls.length - 1];

      if (!Array.isArray(lastRoll) || lastRoll.length < 2) {
        console.warn("lastRoll невалидный:", lastRoll);
        setTournamentNumberMove(0);
        return;
      }

      // Сохраняем в локальный стейт (для отображения)
      setTournamentRolledDice(lastRoll);
      const [d1, d2] = lastRoll;

      // 4) Мой ли это ход?
      const isMyTurn =
        (myColor === "white" && data.currentPlayer === "player1") ||
        (myColor === "black" && data.currentPlayer === "player2");

      if (isMyTurn) {
        // Формируем объект offBoard из ваших двух стейтов:
        const offBoard = {
          white: tournamentWhiteOffBoard,
          black: tournamentBlackOffBoard
        }; 

        // 5) Вызываем "computeRealNumberOfMoves" (расширенную)
        const realMoves = computeRealNumberOfMoves(
          tournamentBoard,             // board
          tournamentCapturedCheckers,  // capturedCheckers
          offBoard,                    // { white: [...], black: [...] }
          myColor,
          d1,
          d2
        );

        setTournamentNumberMove(realMoves);
        
        // Отправляем на сервер
        tournamentSocket.emit('tournamentMatch_updateNumberMove', {
          tableId: parseInt(tournamentTableId, 10),
          currentPlayer: data.currentPlayer,
          numberMove: realMoves
        });
      } else {
        // НЕ мой ход => берём numberMove c сервера (или 0)
        setTournamentNumberMove(data.numberMove || 0);
      }
    }

    // Подписка на событие
    tournamentSocket.on("tournamentMatch_diceRolled", handleDiceRolled);

    // Отписка при размонтировании
    return () => {
      tournamentSocket.off("tournamentMatch_diceRolled", handleDiceRolled);
    };
  }, [
    tournamentTableId,
    tournamentBoard,
    tournamentCapturedCheckers,
    tournamentWhiteOffBoard,
    tournamentBlackOffBoard
  ]);

 

 


function checkTwoMovesPossible(board, captured, offBoard, playerColor, d1, d2) {
  console.log(`[checkTwoMovesPossible] => d1=${d1}, d2=${d2}, color=${playerColor}`);
  if (d1 === d2) {
    // здесь у вас дубль — лучше обрабатывать отдельно
    // (либо возвращать false и в computeRealNumberOfMoves обрабатывать)
    return false;
  }

  // Пробуем (d1 => d2)
  console.log(`[checkTwoMovesPossible] Trying sequence (d1->d2) => (${d1},${d2})`);
  if (attemptTwoMovesSequence(board, captured, offBoard, playerColor, d1, d2)) {
    return true;
  }
  // Пробуем (d2 => d1)
  console.log(`[checkTwoMovesPossible] Trying sequence (d2->d1) => (${d2},${d1})`);
  if (attemptTwoMovesSequence(board, captured, offBoard, playerColor, d2, d1)) {
    return true;
  }
  console.log(`[checkTwoMovesPossible] Both sequences failed => return false`);
  return false;
}


function simulateOneBearOffMove(board, captured, offBoard, fromIndex, moveDist, playerColor) {
  // 1) Копируем
  const tempBoard = deepCopyBoard(board);
  const tempCaptured = { ...captured };
  const tempOffBoard = JSON.parse(JSON.stringify(offBoard));

  // 2) Проверяем, можно ли действительно снять шашку
  //    - allCheckersInHome?
  if (!allCheckersInHome(tempBoard, playerColor)) {
    return null; // ещё не все в доме
  }
  //    - canBearOffChecker?
  if (!canBearOffChecker(fromIndex, moveDist, tempBoard, playerColor)) {
    return null;
  }

  // 3) Снимаем одну шашку с fromIndex
  if (!tempBoard[fromIndex] || !tempBoard[fromIndex].length) {
    return null; // нет шашки
  }
  const checker = tempBoard[fromIndex].pop();

  // 4) Кладём в offBoard
  tempOffBoard[playerColor] = tempOffBoard[playerColor] || [];
  tempOffBoard[playerColor].push(checker);

  // 5) Возвращаем
  return {
    boardAfter: tempBoard,
    capturedAfter: tempCaptured,
    offBoardAfter: tempOffBoard
  };
}


// Пример
function getAllPossibleOneMoves(board, captured, offBoard, playerColor, dieValue) {
  console.log(`[getAllPossibleOneMoves] START => color=${playerColor}, dieValue=${dieValue}`);

  const resultStates = [];

  // 1) Если на баре есть шашки — пробуем ВВОД.
  const barCount = captured[playerColor] || 0;
  if (barCount > 0) {
    console.log(`[getAllPossibleOneMoves] => бар=${barCount}, пытаемся simulateOneEnterFromBar...`);
    const barState = simulateOneEnterFromBar(board, captured, offBoard, dieValue, playerColor);
    if (barState) {
      console.log(`[getAllPossibleOneMoves] => удалось ввод с бара => push в resultStates`);
      resultStates.push(barState);
    } else {
      console.log(`[getAllPossibleOneMoves] => ввод с бара => НЕТ вариантов (null)`);
    }
    // Сразу возвращаем, т.к. при наличии шашек на баре
    // другие (обычные) ходы делать нельзя, пока не освободим бар.
    return resultStates;
  }

  // 2) Если allCheckersInHome => пробуем bear off
  if (allCheckersInHome(board, playerColor)) {
    console.log(`[getAllPossibleOneMoves] => все шашки в доме => пробуем bear off`);
    // Для белых дом = 0..5, для чёрных дом = 18..23
    const homeStart = (playerColor === 'white') ? 0 : 18;
    const homeEnd   = (playerColor === 'white') ? 6 : 24;

    for (let fromIndex = homeStart; fromIndex < homeEnd; fromIndex++) {
      if (!board[fromIndex]?.length) continue;
      if (board[fromIndex][0].color !== playerColor) continue;

      // Проверяем, можно ли именно с fromIndex вынести
      if (canBearOffChecker(fromIndex, dieValue, board, playerColor)) {
        const bearResult = simulateOneBearOffMove(board, captured, offBoard, fromIndex, dieValue, playerColor);
        if (bearResult) {
          console.log(`[getAllPossibleOneMoves] => fromIndex=${fromIndex}, bear off УСПЕХ => push`);
          resultStates.push(bearResult);
        } else {
          console.log(`[getAllPossibleOneMoves] => fromIndex=${fromIndex}, bear off => null`);
        }
      }
    }
  }

  // 3) Обычный ход:
  console.log(`[getAllPossibleOneMoves] => пробуем обычные ходы (simulateOneNormalMove)`);
  for (let fromIndex = 0; fromIndex < 24; fromIndex++) {
    if (!board[fromIndex]?.length) continue;
    if (board[fromIndex][0].color !== playerColor) continue;

    const normalState = simulateOneNormalMove(board, captured, offBoard, fromIndex, dieValue, playerColor);
    if (normalState) {
      console.log(`[getAllPossibleOneMoves] => from=${fromIndex}, normalMove OK => push`);
      resultStates.push(normalState);
    }
  }

  console.log(`[getAllPossibleOneMoves] => total resultStates.length=${resultStates.length}`);
  return resultStates;
}










function attemptTwoMovesSequence(board, captured, offBoard, playerColor, firstDie, secondDie) {
  console.log(`[attemptTwoMovesSequence] START => color=${playerColor}, firstDie=${firstDie}, secondDie=${secondDie}`);

  // 1) Список ВСЕХ возможных позиций после ПЕРВОГО хода (firstDie).
  console.log(`[attemptTwoMovesSequence] => вызываем getAllPossibleOneMoves(...) для firstDie=${firstDie}`);
  const allPossibleFirst = getAllPossibleOneMoves(board, captured, offBoard, playerColor, firstDie);

  // Если вообще нет способов сходить 1-м ходом:
  if (allPossibleFirst.length === 0) {
    console.log(`[attemptTwoMovesSequence] => нет вариантов первого хода => return false`);
    return false;
  }

  console.log(`[attemptTwoMovesSequence] => найдено вариантов первого хода: ${allPossibleFirst.length}`);

  // 2) Для *каждого* результата первого хода пробуем второй
  for (let i = 0; i < allPossibleFirst.length; i++) {
    const firstResult = allPossibleFirst[i];
    console.log(`[attemptTwoMovesSequence] => проверяем второй ход (secondDie=${secondDie}) для варианта #${i+1}/${allPossibleFirst.length}`);

    // secondDie: getAllPossibleOneMoves на *уже обновлённой* позиции
    const allPossibleSecond = getAllPossibleOneMoves(
      firstResult.boardAfter,
      firstResult.capturedAfter,
      firstResult.offBoardAfter,
      playerColor,
      secondDie
    );

    if (allPossibleSecond.length > 0) {
      console.log(`[attemptTwoMovesSequence] => для варианта #${i+1} нашёлся хотя бы 1 способ второго хода => SUCCESS => return true`);
      return true;
    } else {
      console.log(`[attemptTwoMovesSequence] => для варианта #${i+1} второй ход невозможен, переходим к следующему...`);
    }
  }

  // Если перебрали все варианты первого хода — и нигде второй не получился:
  console.log(`[attemptTwoMovesSequence] => перебрали все варианты => не нашли 2й ход => return false`);
  return false;
}


function simulateOneMoveWithBarAndBearOff(board, captured, offBoard, moveDist, playerColor) {
  console.log(`[simulateOneMoveWithBarAndBearOff] => moveDist=${moveDist}, color=${playerColor}`);


  // 1) BAR
  if (captured[playerColor] > 0) {
    console.log(`[simulateOneMoveWithBarAndBearOff] We have checkers on bar => simulateOneEnterFromBar`);
    const barResult = simulateOneEnterFromBar(board, captured, offBoard, moveDist, playerColor);
    // Если удалось, возвращаем. Если null => ход невозможен
    return barResult; // либо null
  }

  // 2) Если все в доме => пытаемся BearOff
  if (allCheckersInHome(board, playerColor)) {
    // Можно перебрать все fromIndex 0..5 (white) или 18..23 (black)
    // но, чтобы сохранить «логику одного» (как attemptBearOff), делаем небольшой цикл:
    for (let i = 0; i < 24; i++) {
      if (!board[i]?.length) continue;
      if (board[i][0].color !== playerColor) continue;
      // Пытаемся снять
      const bearOffResult = simulateOneBearOffMove(
        board, captured, offBoard, i, moveDist, playerColor
      );
      if (bearOffResult) {
        console.log('[simulateOneMoveWithBarAndBearOff] => bear-off SUCCESS from i=', i);
        return bearOffResult; 
      }
    }
    console.log('[simulateOneMoveWithBarAndBearOff] => bear-off FAIL => try normal move');
    // не вернули => значит не вышло => пойдём к "обычному ходу"
  }

  // 3) Обычный ход
  for (let i = 0; i < 24; i++) {
    if (!board[i]?.length) continue;
    if (board[i][0].color !== playerColor) continue;

    const normalResult = simulateOneNormalMove(
      board, captured, offBoard,
      i, moveDist,
      playerColor
    );
    if (normalResult) {
      console.log(`[simulateOneMoveWithBarAndBearOff] normal SUCCESS => from i=${i}`);
      return normalResult;
    }
  }

  // Если всё перебрали — вернём null
  console.log(`[simulateOneMoveWithBarAndBearOff] => NO moves => null`);
  return null;
}



function simulateOneEnterFromBar(originalBoard, originalCaptured, originalOffBoard, dieValue, playerColor) {
  console.log(`[simulateOneEnterFromBar] START => color=${playerColor}, die=${dieValue}`);

  // 1) Копии
  const tempBoard = deepCopyBoard(originalBoard);
  const tempCaptured = { ...originalCaptured };
  const tempOffBoard = JSON.parse(JSON.stringify(originalOffBoard));

  // 2) Целевой индекс
  let targetIndex;
  if (playerColor === 'white') {
    targetIndex = 24 - dieValue;  // если die=3 => target=21
  } else {
    targetIndex = dieValue - 1;   // если die=3 => target=2
  }

  if (targetIndex < 0 || targetIndex > 23) {
    console.log(`[simulateOneEnterFromBar] => targetIndex=${targetIndex} за границами => return null`);
    return null;
  }

  // Если на targetIndex 2+ чужих шашек — нельзя
  if (
    tempBoard[targetIndex]?.length > 1 &&
    tempBoard[targetIndex][0].color !== playerColor
  ) {
    console.log(`[simulateOneEnterFromBar] => там >1 чужих => return null`);
    return null;
  }

  // Если на баре нет шашек
  if (tempCaptured[playerColor] <= 0) {
    console.log(`[simulateOneEnterFromBar] => bar=0 => return null`);
    return null;
  }

  // 3) Снимаем 1 шашку с бара
  tempCaptured[playerColor]--;

  // Если там 1 чужая => сбиваем
  if (
    tempBoard[targetIndex]?.length === 1 &&
    tempBoard[targetIndex][0].color !== playerColor
  ) {
    const victim = tempBoard[targetIndex].pop();
    const opp = victim.color;
    tempCaptured[opp] = (tempCaptured[opp]||0) + 1;
    console.log(`[simulateOneEnterFromBar] => сбили чужую шашку opp=${opp}`);
  }

  // 4) Ставим нашу
  tempBoard[targetIndex] = tempBoard[targetIndex] || [];
  tempBoard[targetIndex].push({ color: playerColor });

  console.log(`[simulateOneEnterFromBar] => УСПЕШНО, return { boardAfter, capturedAfter, offBoardAfter }`);
  return {
    boardAfter: tempBoard,
    capturedAfter: tempCaptured,
    offBoardAfter: tempOffBoard
  };
}



/** Проверяем, «все ли шашки playerColor находятся в доме». */
function allCheckersInHome(board, playerColor) {
  if (playerColor === 'white') {
    // дом для белых — ячейки 0..5
    // значит не должно быть белых на 6..23
    for (let i = 6; i < 24; i++) {
      if (board[i]?.some(ch => ch.color === 'white')) {
        return false;
      }
    }
    return true;
  } else {
    // чёрный дом — ячейки 18..23
    for (let i = 0; i < 18; i++) {
      if (board[i]?.some(ch => ch.color === 'black')) {
        return false;
      }
    }
    return true;
  }
}


function simulateOneBearOffMove(originalBoard, originalCaptured, originalOffBoard, fromIndex, dieValue, playerColor) {
  console.log(`[simulateOneBearOffMove] => fromIndex=${fromIndex}, die=${dieValue}, color=${playerColor}`);

  const tempBoard = deepCopyBoard(originalBoard);
  const tempCaptured = { ...originalCaptured };
  const tempOffBoard = JSON.parse(JSON.stringify(originalOffBoard));

  // Проверим, есть ли там действительно наша шашка
  if (!tempBoard[fromIndex]?.length || tempBoard[fromIndex][0].color !== playerColor) {
    console.log(`[simulateOneBearOffMove] => нет нашей шашки на fromIndex=${fromIndex} => null`);
    return null;
  }

  // Имеем ли право вынести? (canBearOffChecker + allCheckersInHome)
  if (!allCheckersInHome(tempBoard, playerColor)) {
    console.log(`[simulateOneBearOffMove] => не все шашки в доме => null`);
    return null;
  }
  if (!canBearOffChecker(fromIndex, dieValue, tempBoard, playerColor)) {
    console.log(`[simulateOneBearOffMove] => canBearOffChecker вернул false => null`);
    return null;
  }

  // Снимаем
  const checker = tempBoard[fromIndex].shift();
  // Кладём в offBoard
  tempOffBoard[playerColor] = tempOffBoard[playerColor]||[];
  tempOffBoard[playerColor].push(checker);

  console.log(`[simulateOneBearOffMove] => УСПЕХ, вынесли => return { ... }`);
  return {
    boardAfter: tempBoard,
    capturedAfter: tempCaptured,
    offBoardAfter: tempOffBoard
  };
}






/** Проверяет, можно ли С ОДНОЙ конкретной позиции fromIndex снять шашку (bear off) при moveDist. */
function canBearOffChecker(fromIndex, moveDist, board, playerColor) {
  if (playerColor === 'white') {
    const dist = fromIndex + 1; // если fromIndex=5 => dist=6
    if (moveDist === dist) return true;
    if (moveDist > dist) {
      // проверяем, нет ли более дальних белых
      for (let i = fromIndex + 1; i <= 5; i++) {
        if (board[i]?.some(ch => ch.color === 'white')) return false;
      }
      return true;
    }
    return false;
  } else {
    // чёрные
    const dist = 24 - fromIndex; // если fromIndex=19 => dist=5
    if (moveDist === dist) return true;
    if (moveDist > dist) {
      for (let i = fromIndex - 1; i >= 18; i--) {
        if (board[i]?.some(ch => ch.color === 'black')) return false;
      }
      return true;
    }
    return false;
  }
}


function simulateOneNormalMove(originalBoard, originalCaptured, originalOffBoard, fromIndex, dieValue, playerColor) {
  console.log(`[simulateOneNormalMove] => from=${fromIndex}, die=${dieValue}, color=${playerColor}`);

  const tempBoard = deepCopyBoard(originalBoard);
  const tempCaptured = { ...originalCaptured };
  const tempOffBoard = JSON.parse(JSON.stringify(originalOffBoard));

  // Проверяем, есть ли там наша шашка
  if (!tempBoard[fromIndex]?.length || tempBoard[fromIndex][0].color !== playerColor) {
    console.log(`[simulateOneNormalMove] => там нет нашей шашки => return null`);
    return null;
  }

  // Вычисляем targetIndex
  let targetIndex;
  if (playerColor === 'white') {
    targetIndex = fromIndex - dieValue;
  } else {
    targetIndex = fromIndex + dieValue;
  }

  if (targetIndex < 0 || targetIndex >= 24) {
    console.log(`[simulateOneNormalMove] => target=${targetIndex} за границей => return null`);
    return null;
  }

  // Если там >1 чужих
  if (
    tempBoard[targetIndex]?.length > 1 &&
    tempBoard[targetIndex][0].color !== playerColor
  ) {
    console.log(`[simulateOneNormalMove] => 2+ чужих => null`);
    return null;
  }

  // Снимаем нашу
  const movingChecker = tempBoard[fromIndex].shift();

  // Если 1 чужая => сбиваем
  if (
    tempBoard[targetIndex]?.length === 1 &&
    tempBoard[targetIndex][0].color !== playerColor
  ) {
    const victim = tempBoard[targetIndex].pop();
    tempCaptured[victim.color] = (tempCaptured[victim.color]||0)+1;
    console.log(`[simulateOneNormalMove] => сбили чужую (color=${victim.color})`);
  }

  // Ставим свою
  tempBoard[targetIndex] = tempBoard[targetIndex]||[];
  tempBoard[targetIndex].push(movingChecker);

  console.log(`[simulateOneNormalMove] => УСПЕХ => return { ... }`);
  return {
    boardAfter: tempBoard,
    capturedAfter: tempCaptured,
    offBoardAfter: tempOffBoard
  };
}

/** Простая deep-копия */
function deepCopyBoard(board) {
  return board.map(stack => stack.map(ch => ({ ...ch })));
}



useEffect(() => {
  function handleTableClosed(payload) {
    // server может прислать winner/loser позже — попробуем их взять:
    const merged = {
      winner: payload?.winner ?? lastOutcome?.winner,
      loser: payload?.loser ?? lastOutcome?.loser,
      isSemiFinal: payload?.isSemiFinal ?? lastOutcome?.isSemiFinal,
      isFinal: payload?.isFinal ?? lastOutcome?.isFinal,
      reason: payload?.reason ?? lastOutcome?.reason
    };

    // Уберём tableId и покажем корректное сообщение итога
    localStorage.removeItem('tableId');
    showOutcomeAndExit(merged);
  }

  tournamentSocket.on('tournament_tableClosed', handleTableClosed);
  return () => tournamentSocket.off('tournament_tableClosed', handleTableClosed);
}, [lastOutcome, showOutcomeAndExit]);


 
useEffect(() => {
  console.log('[Effect] Проверка условий:', {
    hasRolled: tournamentHasRolledDice,
    initialPhase: initialRollPhase,
  });

  // if (!tournamentHasRolledDice || !initialRollPhase) {
  if (!tournamentHasRolledDice) {
    console.log('[Effect] Выход: условия не выполнены');
    return;
  }

  console.log('[Effect] Начало расчета ходов...');
  
  let dice = [...tournamentRolledDice];
  if (dice[0] === dice[1]) {
    dice = Array(4).fill(dice[0]);
  }

  const remainingRolls = tournamentCalculateRemainingRolls(dice, []);
  console.log('Оставшиеся броски:', remainingRolls);


}, [tournamentHasRolledDice, initialRollPhase, tournamentRolledDice, tournamentBoard, tournamentPlayerColor]);




function tournamentCalculateRemainingRolls(rolledDice, usedRolls) {
  // Пример (упрощённый)
  if (!rolledDice || rolledDice.length === 0) return [];

  let expanded;
  if (rolledDice[0] === rolledDice[1]) {
    // дубль => 4 копии
    expanded = [rolledDice[0], rolledDice[0], rolledDice[0], rolledDice[0]];
  } else {
    // обычный бросок => [d1,d2]
    expanded = [...rolledDice];
  }

  // Убираем уже использованные
  let remaining = [...expanded];
  for (let used of usedRolls) {
    const idx = remaining.indexOf(used);
    if (idx !== -1) {
      remaining.splice(idx, 1);
    }
  }

  return remaining;
}








// 2) Считает, для текущей доски и массива неиспользованных значений,
//    сколько *максимум* ещё ходов можно сделать.
function calculateMaxMovesOverall(board, playerColor, diceArray) {
  let totalMoves = 0;
  for (let i = 0; i < board.length; i++) {
    if (board[i]?.length && board[i][0].color === playerColor) {
      // Проверяем, сколько значений из diceArray дают *валидный* ход
      for (let die of diceArray) {
        const target = (playerColor === 'white') ? i - die : i + die;
        if (target < 0 || target >= 24) continue; // вне доски
        const targetPoint = board[target];
        // Можно ходить, если пусто, свои шашки, или 1 чужая (битие)
        if (
          !targetPoint ||
          targetPoint.length === 0 ||
          targetPoint.every(ch => ch.color === playerColor) ||
          (targetPoint.length === 1 && targetPoint[0].color !== playerColor)
        ) {
          totalMoves++;
        }
      }
    }
  }
  // Тут вопрос, складывать ли мы *все* потенциальные (totalMoves), ведь часть может пересекаться.
  // Простой вариант: вернуть totalMoves (обычно это «переоценка»). 
  // Более точный метод — проверка комбинирования. Но для упрощённой логики пойдёт.
  return totalMoves;
}




// внутри TournamentMatch.jsx / .tsx
useEffect(() => {
  /**
   * Получаем бросок, рассылаемый сервером,
   * и полностью настраиваем локальный state.
   */
  function handleAutoFirstRoll({
  tableId,
  player1Roll,
  player2Roll,
  currentTurn,
  numberMovePlayer1,
  numberMovePlayer2,
  firstRollComplete,
  firstMoveComplete,
  hasRolledDicePlayer1,
  hasRolledDicePlayer2,
}) {
  if (
    String(tableId) !==
    String(tournamentTableId)
  ) {
    return;
  }

  const p1Die = Number(player1Roll);
  const p2Die = Number(player2Roll);

  const openingDice = [
    p1Die,
    p2Die
  ].filter(
    (die) =>
      Number.isInteger(die) &&
      die >= 1 &&
      die <= 6
  );

  /*
   * Сохраняем стартовые значения отдельно.
   */
  setTournamentFirstRolls({
    player1Roll: p1Die,
    player2Roll: p2Die
  });

  /*
   * Эти два значения используются победителем
   * первого броска для первого хода.
   */
  setTournamentRolledDice(openingDice);

  setTournamentCurrentTurn(
    currentTurn || null
  );

  /*
   * numberMove должен соответствовать тому,
   * кто сейчас ходит, а не цвету текущего клиента.
   */
  const currentNumberMove =
    currentTurn === 'player1'
      ? Number(numberMovePlayer1 ?? 0)
      : currentTurn === 'player2'
        ? Number(numberMovePlayer2 ?? 0)
        : 0;

  setTournamentNumberMove(
    currentNumberMove
  );

  /*
   * Определяем, есть ли кубики именно
   * у текущего игрока.
   */
  const currentPlayerHasRolled =
    currentTurn === 'player1'
      ? Boolean(hasRolledDicePlayer1)
      : currentTurn === 'player2'
        ? Boolean(hasRolledDicePlayer2)
        : false;

  setTournamentHasRolledDice(
    currentPlayerHasRolled ||
    openingDice.length === 2
  );

  /*
   * Критически важно:
   *
   * firstRollComplete === true:
   * определение очереди завершено.
   *
   * firstMoveComplete === false:
   * первый игровой ход ещё не завершён.
   */
  setTournamentFirstRollComplete(
    Boolean(firstRollComplete)
  );

  setFirstMoveComplete(
    Boolean(firstMoveComplete)
  );

  setRollButtonEnabled(false);

  console.log(
    '[TournamentMatch] Получен первый бросок:',
    {
      tableId,
      openingDice,
      currentTurn,
      currentNumberMove,
      firstRollComplete,
      firstMoveComplete
    }
  );
}
//   function handleAutoFirstRoll({
//     tableId,
//     player1Roll,
//     player2Roll,
//     currentTurn,
//     numberMovePlayer1,
//     numberMovePlayer2,
//     firstRollComplete,
//   }) {
//     if (String(tableId) !== String(tournamentTableId)) return;

//     /* 1. Сохраняем кубики для отображения */
//     setTournamentFirstRolls({ player1Roll, player2Roll });
//     setTournamentRolledDice([player1Roll, player2Roll]);
//     setTournamentHasRolledDice(true);

//     /* 2. Чья очередь? */
//     setTournamentCurrentTurn(currentTurn);

//     const iAmWhite  = tournamentPlayerColor === 'white';
//     const movesLeft = iAmWhite ? numberMovePlayer1 : numberMovePlayer2;
//     setTournamentNumberMove(movesLeft);

//     /* 3. Если ходов нет – сразу сдаём ход (автопасс) */
//     // if (movesLeft === 0) {
//     //   setTimeout(() => tournamentConfirmMove(), 50);
//     // }
// if (movesLeft === 0 && !hasAutoConfirmedRef.current) {
//   hasAutoConfirmedRef.current = true;
//   setTimeout(() => tournamentConfirmMove(), 50);
// }

//     /* 4. Отмечаем, что первый бросок получен, но ещё не подтверждён */
//     setTournamentFirstRollComplete(firstRollComplete);
//     setFirstMoveComplete(firstRollComplete);

//     /* 5. Кнопка “Roll” не нужна в первом автобрроске */
//     setRollButtonEnabled(false);
//   }

  tournamentSocket.on('tournamentMatch_autoFirstRoll', handleAutoFirstRoll);
  return () =>
    tournamentSocket.off('tournamentMatch_autoFirstRoll', handleAutoFirstRoll);
}, [
  tournamentTableId,
  tournamentPlayerColor,
  tournamentConfirmMove,
]);





/*
 * Страховка только для стартового хода.
 *
 * В стартовом ходе сервер всегда даёт два разных кубика.
 * Когда оба значения уже использованы,
 * принудительно ставим numberMove = 0,
 * чтобы появилась кнопка "Завершить ход".
 *
 * Обычные последующие ходы этот эффект не затрагивает.
 */




useEffect(() => {
  if (showModal && lastOutcome) {
    const timer = setTimeout(() => {
      try {
        localStorage.removeItem('tournamentTableId'); // 💣 удаляем ID старого стола
      } catch (e) {
        console.warn('Не удалось очистить tournamentTableId', e);
      }

      setShowModal(false);
      navigate("/"); // теперь точно в лобби
    }, 300000);

    return () => clearTimeout(timer);
  }
}, [showModal, lastOutcome]);



useEffect(() => {
  if (!tournamentFirstRollComplete) {
    // console.log('[Tournament] Первый бросок: Сохраняем кубики для использования');
    const rolls = [tournamentFirstRolls.player1Roll, tournamentFirstRolls.player2Roll];
    // setTournamentRolledDice(rolls); // Устанавливаем кубики как доступные для текущего хода
    setTournamentUsedRolls([]); // Сбрасываем использованные броски
  }
}, [tournamentFirstRolls, tournamentFirstRollComplete]);


const handleTournamentFirstMove = (index, realIndex, rollValue) => {
  // console.log('[Tournament] Используем значение кубика для первого броска:', rollValue);

  // Ваша логика перемещения шашки
  const newBoard = [...tournamentBoard];
  const checker = newBoard[index].pop();
  newBoard[realIndex].push(checker);

  // setTournamentBoard(newBoard);

  // Добавляем использованный бросок
  setTournamentUsedRolls((prev) => [...prev, rollValue]);

  // Уменьшаем доступные ходы
  setTournamentNumberMove((prev) => prev - 1);
  setTournamentRolledDice([])
  
};






  




useEffect(() => {
  function handleTournamentMatchGameUpdated(payload) {
    console.log('[Tournament] Подтверждено сервером:', payload); 

      if (payload.tournamentStageLabel || payload.stageLabel) {
    setTournamentStageLabel(payload.tournamentStageLabel ?? payload.stageLabel ?? '');
  }
  if (payload.hasOwnProperty('tournamentPrize')) {
    setTournamentPrize(payload.tournamentPrize);
  }


    // setTournamentBoard(payload.boardState || []);
    setTournamentCurrentTurn(payload.currentTurn || null);
    setTournamentPlayer1Name(payload.player1Name || '');
    setTournamentPlayer2Name(payload.player2Name || '');
    // берем из payload.yourColor
    setTournamentPlayerColor(payload.yourColor || 'white');

setPlayer1Avatar(payload.player1_avatar ?? null);
setPlayer2Avatar(payload.player2_avatar ?? null);
setPlayer1ShortRating(
  typeof payload.player1_short_rating === 'number' ? payload.player1_short_rating : 1200
);
setPlayer2ShortRating(
  typeof payload.player2_short_rating === 'number' ? payload.player2_short_rating : 1200
);

  // Определяем текущий игрок и обновляем состояние "бросил кубики"
  const isPlayer1 = payload.yourColor === 'white';
  const hasRolledDice = isPlayer1
    ? payload.hasRolledDicePlayer1
    : payload.hasRolledDicePlayer2;
  
  setTournamentHasRolledDice(hasRolledDice);
  


  if (payload.tournamentStageLabel || payload.stageLabel) {
    setTournamentStageLabel(payload.tournamentStageLabel ?? payload.stageLabel ?? '');
  }
  if (payload.tournamentId != null) {
    setTournamentId(Number(payload.tournamentId));
  }
    // Только устанавливаем rolledDice, если оно присутствует в payload
    if (payload.hasOwnProperty('rolledDice')) {
      if (Array.isArray(payload.player2_rolls) && payload.player2_rolls.length > 0) {
        setTournamentRolledDice(payload.player2_rolls);
        console.log('92384908234',tournamentRolledDice);
        
        // setTournamentHasRolledDice(true);
        // setTournamentNumberMove(payload.numberMove || 2); // Установите число ходов из payload, если есть
        setTournamentNumberMove(
             payload.numberMove !== undefined
               ? payload.numberMove
               : 0
           );
           console.log('STOP #1')
        // console.log('[TournamentMatch] Установлены rolledDice из gameUpdated:', payload.rolledDice);
        // console.log('[TournamentMatch] Установлено numberMove из gameUpdated:', payload.numberMove || 2);
      } else {
        // setTournamentHasRolledDice(payload.hasRolledDice || false);
        setTournamentNumberMove(0);
        console.log('STOP #1')
        // console.log('[TournamentMatch] rolledDice отсутствуют или пусты в gameUpdated');
      }
      
    }

    setTournamentLoading(false);
  }

  tournamentSocket.on('tournamentMatch_gameUpdated', handleTournamentMatchGameUpdated);
  return () => {
    tournamentSocket.off('tournamentMatch_gameUpdated', handleTournamentMatchGameUpdated);
  };
}, [
  setTournamentBoard,
  setTournamentCurrentTurn,
  setTournamentPlayer1Name,
  setTournamentPlayer2Name,
  setTournamentPlayerColor,
  setTournamentRolledDice,
  setTournamentHasRolledDice,
  setTournamentNumberMove
]);




  
  useEffect(() => {
    // Проверяем, мой ли ход
    const isMyTurn = (
      (tournamentPlayerColor === 'white' && tournamentCurrentTurn === 'player1')
      || (tournamentPlayerColor === 'black' && tournamentCurrentTurn === 'player2')
    );
    if (!isMyTurn || !tournamentHasRolledDice) {
      return;
    }
  
    // 1) Получаем remainingRolls
    const remainingRolls = tournamentCalculateRemainingRolls(
      tournamentRolledDice,
      tournamentUsedRolls
    );
  
    // Здесь вместо 'board' и 'playerColor' используем tournamentBoard и tournamentPlayerColor
    // const canNormalMove = canMakeAnyNormalMove(
    //   remainingRolls,
    //   tournamentBoard,
    //   tournamentPlayerColor
    // );
  
    // 2) Вызываем функцию проверки бара
    const noBarMoves = tournamentCheckBarMoveAvailability(
      remainingRolls,
      tournamentBoard,
      tournamentCapturedCheckers,
      tournamentPlayerColor
    );
  
    console.log("[Tournament] Нет возможности войти с бара => вынужден пропуск", noBarMoves);
  
    // if (!canNormalMove ) {
    //   console.log("[Tournament] Нет возможности войти с бара => вынужден пропуск");
    //   setTournamentNumberMove(0);
    //   // tournamentConfirmMove();
    // }
    if(noBarMoves){
      setTournamentNumberMove(0);
      console.log('STOP #1')
    }
  }, [
    tournamentPlayerColor,
    tournamentCurrentTurn,
    tournamentHasRolledDice,
    tournamentBoard,
    tournamentCapturedCheckers,
    tournamentRolledDice, 
    tournamentUsedRolls,
    tournamentFirstRolls, 
    tournamentFirstRollComplete
  ]);
  
  
  const pillClass = (name, match) => {
  if (!name) return 'pill';
  if (match?.winner === name) return 'pill pill--win';
  if (match?.loser  === name) return 'pill pill--lose';
  return 'pill';
};




useEffect(() => {
  function handleGameFinished(data) {
    const { winner, loser, isSemiFinal, isFinal, reason } = data || {};
// если это полуфинал и сервер прислал свежий список столов — перезапишем оба слота
if (isSemiFinal && Array.isArray(data?.semifinalTables)) {
  replaceSemisFromSnapshot(data.semifinalTables);
}

    // обновляем мини-брекет
    applyMatchResult({ winner, loser, isFinal: !!isFinal });
   if (!isFinal) tournamentSocket.emit('requestAllTournaments');
   if (isFinal) {
    patchRounds(rs => {
      const fi = rs.findIndex(r => labelIsFinal(r.label));
      if (fi === -1) return;
      const m = { ...(rs[fi].matches?.[0] || {}) };
      rs[fi].matches[0] = {
        ...m,
        a: m.a || winner,   // подстраховка, если пара не успела приехать
        b: m.b || loser,
        winner,
        loser: loser ?? m.loser
      };
    });
  }
    // запомним исход, покажем сообщение и навигацию
    localStorage.removeItem('tableId');
    setLastOutcome({ winner, loser, isSemiFinal, isFinal, reason });
    showOutcomeAndExit({ winner, loser, isSemiFinal, isFinal, reason });
  }

  tournamentSocket.on('tournamentMatch_gameFinished', handleGameFinished);
  return () => tournamentSocket.off('tournamentMatch_gameFinished', handleGameFinished);
}, [showOutcomeAndExit,replaceSemisFromSnapshot]);





  
  const handleTournamentRollDiceClick = () => {
    
    console.log('[client] handleTournamentRollDiceClick called');
    const isMyTurn =
      (tournamentPlayerColor === 'white' && tournamentCurrentTurn === 'player1') ||
      (tournamentPlayerColor === 'black' && tournamentCurrentTurn === 'player2');
      setTournamentHasRolledDice(true); 
      setTournamentRollEnabled(false);
      setInitialRollPhase(true); // Добавьте эту строку
    console.log('[emit] tournamentMatch_rollDice =>', {
      tableId: parseInt(tournamentTableId, 10),
      currentPlayer: tournamentCurrentTurn
    });
  
    if (isMyTurn && !tournamentHasRolledDice) {
      tournamentSocket.emit('tournamentMatch_rollDice', {
        tableId: parseInt(tournamentTableId, 10),
        currentPlayer: tournamentCurrentTurn
      });
    
    }
 
  };
  
   

  //////////////////////////////////////////////////////////////////////////
  // Рендер
  //////////////////////////////////////////////////////////////////////////
  if (tournamentLoading) {
    return <div><h1>{translate('jackpotBoard.loadingTournament')}</h1></div>;
  }
  if (tournamentError) {
    return <div style={{ color: 'red' }}>{translate('jackpotBoard.errorPrefix')} {tournamentError}</div>;
  }

 




function tournamentOnPointClick(index, realIndex) {
  ////////////////////////////////////////////////
  // 1) Базовые проверки
  ////////////////////////////////////////////////
  const isMyTurn =
    (tournamentCurrentTurn === (tournamentPlayerColor === 'white' ? 'player1' : 'player2'));
  if (!isMyTurn) return;

  // Если кубики не брошены (и это не самый первый ход):
  if (!tournamentHasRolledDice && tournamentFirstRollComplete) {
    return;
  }

  if (tournamentNumberMove <= 0) {
    return;
  }

  // Если есть шашки на баре – сначала вводим с бара
  const barCount = tournamentCapturedCheckers[tournamentPlayerColor] || 0;
  if (barCount > 0) {
    alert(translate('jackpotBoard.enterFromBarFirst'));
    return;
  }

  // Проверяем, что сверху действительно наша шашка
  const topChecker = tournamentBoard[index]?.[tournamentBoard[index].length - 1];
  if (!topChecker || topChecker.color !== tournamentPlayerColor) {
    return;
  }

  // Запоминаем тип хода «click» (для возможного Undo)
  setTournamentLastMoveType('click');

  ////////////////////////////////////////////////
  // 2) Собираем «оставшиеся» кубики (remainingRolls)
  ////////////////////////////////////////////////
  let remainingRolls;
if (tournamentFirstRollComplete && !firstMoveComplete) {
    // Это самый первый ход (до confirm первого)
    // Берём по логике: если я белый, то [p1Roll, p2Roll], иначе наоборот
    const firstMoveRolls = [
      (tournamentPlayerColor === 'white')
        ? tournamentFirstRolls.player1Roll
        : tournamentFirstRolls.player2Roll,
      (tournamentPlayerColor === 'white')
        ? tournamentFirstRolls.player2Roll
        : tournamentFirstRolls.player1Roll,
    ];
    remainingRolls = firstMoveRolls.filter(r => !tournamentUsedRolls.includes(r));
  } else {
    // Обычный ход
    remainingRolls = tournamentRolledDice.filter(r => !tournamentUsedRolls.includes(r));
  }

  // Если выпал дубль, «раскладываем» до 4
  if (tournamentRolledDice.length === 2 && (tournamentRolledDice[0] === tournamentRolledDice[1])) {
    const dieVal = tournamentRolledDice[0];
    const usedTimes = tournamentUsedRolls.filter(x => x === dieVal).length;
    const totalLeft = 4 - usedTimes; // сколько ещё раз можно использовать дубль
    for (let i = 0; i < totalLeft; i++) {
      remainingRolls.push(dieVal);
    }
  }

  // Сортируем их по убыванию,
  // чтобы приоритетным было «большее» значение кубика
  remainingRolls.sort((a, b) => b - a);

  ////////////////////////////////////////////////
  // 3) Проверка «все ли шашки в доме» (Bear Off)
  ////////////////////////////////////////////////
  if (allCheckersInHome(tournamentBoard, tournamentPlayerColor)) {
    // Пробуем каждый возможный leftoverRoll
    for (let dieVal of remainingRolls) {
      if (canBearOffChecker(index, dieVal, tournamentBoard, tournamentPlayerColor)) {
        // === (A) Снимаем шашку
        const { newBoard, checker } = handleBearOff(
          index,
          dieVal,
          tournamentBoard,
          tournamentPlayerColor,
          tournamentWhiteOffBoard,
          tournamentBlackOffBoard,
          setTournamentWhiteOffBoard,
          setTournamentBlackOffBoard
        );

        // === (B) Запоминаем ход в history (для Undo)
        setTournamentMoveHistory(prev => [
          ...prev,
          {
            from: index,
            to: 'off',
            checker,
            capturedChecker: null,
            board: tournamentDeepCopyBoard(newBoard),
            diceValuesUsed: [dieVal],
            updatedCapturedCheckers: { ...tournamentCapturedCheckers },
            numberMove: tournamentNumberMove,
          }
        ]);

        // === (C) Обновляем usedRolls, numberMove и board
        setTournamentUsedRolls(prev => [...prev, dieVal]);
        setTournamentNumberMove(prev => prev - 1);
        setTournamentBoard(newBoard);

        // === (D) Отправляем «фиксированный» update (bear off) на сервер
        //     (обычно bear off сохраняется сразу в БД)
        const updatedWhiteOff = [...tournamentWhiteOffBoard];
        const updatedBlackOff = [...tournamentBlackOffBoard];
        // (handleBearOff уже внёс в setTournamentWhiteOffBoard / blackOffBoard),
        // но если нужно локально прочитать:
        // - Если color=white => updatedWhiteOff.push(checker);
        // - Если color=black => updatedBlackOff.push(checker);

        tournamentSocket.emit('tournamentMatch_updateBoardState', {
          tableId: parseInt(tournamentTableId, 10),
          boardState: newBoard,
          player: (tournamentPlayerColor === 'white') ? 'player1' : 'player2',
          updatedCapturedCheckers: { ...tournamentCapturedCheckers },
          whiteOffBoard: tournamentPlayerColor === 'white'  
            ? [...updatedWhiteOff, checker]
            : updatedWhiteOff,
          blackOffBoard: tournamentPlayerColor === 'black'
            ? [...updatedBlackOff, checker]
            : updatedBlackOff,
          ephemeral: true, // Bear off сразу «зафиксируем» на сервере
        });

        // === (E) Проверяем, остались ли у нас ещё ходы
        setTimeout(() => {
          checkIfAnyMovesLeft(/* usedDie= */ dieVal, newBoard, tournamentCapturedCheckers);
        }, 0);

        // Выходим, т.к. уже сходили
        return;
      }
    }
  }

  ////////////////////////////////////////////////
  // 4) Обычный ход (без Bear Off)
  ////////////////////////////////////////////////
  let chosenDie = null;
  let finalBoard = null;
  let finalCaptured = null;
  let finalCapturedChecker = null;
  let targetIndex = -1;
  let foundMove = false;

  // Проходим по remainingRolls (от большего к меньшему)
  for (let dieVal of remainingRolls) {
    // Целевая позиция
    const candidateTarget = (tournamentPlayerColor === 'white')
      ? (index - dieVal)
      : (index + dieVal);

    if (candidateTarget < 0 || candidateTarget >= 24) {
      // вне диапазона => пропускаем
      continue;
    }

    // Если там 2+ чужих => нельзя
    const stackAtTarget = tournamentBoard[candidateTarget] || [];
    if (
      stackAtTarget.length > 1 &&
      stackAtTarget[0].color !== tournamentPlayerColor
    ) {
      continue;
    }

    // Копируем и пробуем «simulateOneMove»
    const boardCopy = tournamentDeepCopyBoard(tournamentBoard);
    const capturedCopy = { ...tournamentCapturedCheckers };

    const sim = simulateOneMove(
      boardCopy,
      capturedCopy,
      { fromIndex: index, moveDist: dieVal, playerColor: tournamentPlayerColor }
    );
    if (!sim) {
      // Ход невозможен => ищем следующий dieVal
      continue;
    }

    // === (A) Если у нас ещё >=2 ходов и броски разные (5-6, а не дубль),
    //         нужно проверить, **не блокируем** ли мы второй ход.
    //         Т.е. есть ли возможность сыграть «оставшийся» кубик(и).
    //         При этом второй ход может оказаться Bear Off (если после первого
    //         в дом зашла последняя шашка).
    if (tournamentRolledDice[0] !== tournamentRolledDice[1] && tournamentNumberMove >= 2) {
      // leftoverAfter убираем dieVal
      const leftoverAfter = removeOneDistFromArray(remainingRolls, dieVal);

      // Проверяем, есть ли хотя бы один возможный ход,
      // включая bear off, на «обновлённой» доске sim.boardAfter
      const canSecond = canMakeAtLeastOneMove(
        sim.boardAfter,
        sim.capturedAfter,
        leftoverAfter,
        tournamentPlayerColor
      );
      // Дополнительно проверяем, можно ли bear off (вдруг теперь все вошли в дом)
      const canBearSecond = canBearOffAny(
        sim.boardAfter,
        leftoverAfter,
        tournamentPlayerColor
      );

      if (!canSecond && !canBearSecond) {
        // Этот ход «блокирует» второй кубик => пропускаем
        alert(translate('jackpotBoard.secondDieBlocked'));
        continue;
      }
    }

    // Если дошли сюда => ход допустим
    chosenDie = dieVal;
    foundMove = true;
    targetIndex = candidateTarget;
    finalBoard = sim.boardAfter;
    finalCaptured = sim.capturedAfter;
    finalCapturedChecker = sim.capturedChecker;
    break; // выходим из цикла по кубикам
  }

  if (!foundMove || !finalBoard) {
    // Вообще не нашлось хода => выходим
    return;
  }

  ////////////////////////////////////////////////
  // 5) Применяем ход окончательно
  ////////////////////////////////////////////////
  // 5.1) Пишем в history для Undo
  setTournamentMoveHistory(prev => [
    ...prev,
    {
      from: index,
      to: targetIndex,
      checker: { color: tournamentPlayerColor },
      capturedChecker: finalCapturedChecker || null,
      board: tournamentDeepCopyBoard(finalBoard),
      diceValuesUsed: [chosenDie],
      updatedCapturedCheckers: { ...finalCaptured },
      numberMove: tournamentNumberMove,
    }
  ]);

  // 5.2) Уменьшаем `numberMove` и записываем usedRolls
setTournamentUsedRolls((prev) => [
  ...prev,
  chosenDie
]);

setTournamentNumberMove((prev) =>
  Math.max(Number(prev || 0) - 1, 0)
);

  // 5.3) Обновляем board / captured
  setTournamentBoard(finalBoard);
  setTournamentCapturedCheckers(finalCaptured);

  // 5.4) Проверяем, остались ли ещё ходы
  setTimeout(() => {
    checkIfAnyMovesLeft(chosenDie, finalBoard, finalCaptured);
  }, 0);

  // 5.5) Отправляем «эфемерное» обновление (без confirm)
  //      чтобы оппонент увидел новый расклад
  tournamentSocket.emit('tournamentMatch_updateBoardState', {
    tableId: parseInt(tournamentTableId, 10),
    boardState: finalBoard,
    player: (tournamentPlayerColor === 'white') ? 'player1' : 'player2',
    updatedCapturedCheckers: { ...finalCaptured },
    whiteOffBoard: tournamentWhiteOffBoard,
    blackOffBoard: tournamentBlackOffBoard,
    ephemeral: true,
  });

  ////////////////////////////////////////////////
  // Вспомогательная функция checkIfAnyMovesLeft
  ////////////////////////////////////////////////
  function checkIfAnyMovesLeft(usedDie, currentBoard, currentCaptured) {
    // Если это *самый первый* ход (до confirm)
    // и мы ещё не закончили «первый бросок», можно пропустить
    if (!tournamentFirstRollComplete && !firstMoveComplete) {
      return;
    }

    // leftoverDice – убираем только что использованный usedDie
    const leftoverDice = usedDie
      ? tournamentCalculateRemainingRolls(
          tournamentRolledDice,
          [...tournamentUsedRolls, usedDie]
        )
      : tournamentCalculateRemainingRolls(
          tournamentRolledDice,
          [...tournamentUsedRolls]
        );

    // Проверяем, есть ли хоть один ход
    const canMoveFurther = canMakeAtLeastOneMove(
      currentBoard || tournamentBoard,
      currentCaptured || tournamentCapturedCheckers,
      leftoverDice,
      tournamentPlayerColor
    );
    const canBearFurther = canBearOffAny(
      currentBoard || tournamentBoard,
      leftoverDice,
      tournamentPlayerColor
    );

    if (!canMoveFurther && !canBearFurther) {
      // Всё, ходов нет
      setTournamentNumberMove(0);
    }
  }
}




  
// ========================
//  DragStart
// ========================
function tournamentHandleDragStart(e, pointIndex, checkerIndex, isFromBar = false) {
  // Сохраняем в dataTransfer любую нужную информацию:
  const dragData = {
    pointIndex,
    checkerIndex,
    isFromBar
  };
  e.dataTransfer.setData('text', JSON.stringify(dragData));

  console.log('[Tournament] DragStart =>', dragData);
}


// ========================
//  DragOver
// ========================
function handleTournamentDragOver(e) {
  // Разрешаем сброс (drop) по-умолчанию
  e.preventDefault();
}






// ========================
//  DragOver
// ========================
function handleTournamentDragOver(e) {
  e.preventDefault();
}

// ========================
//  DragDrop
// ========================
function tournamentHandleDrop(e, targetIndex) {
  e.preventDefault();

  // -- 1) Проверка: мой ход, есть ли numberMove>0? --
  const isMyTurn =
    (tournamentPlayerColor === 'white' && tournamentCurrentTurn === 'player1') ||
    (tournamentPlayerColor === 'black' && tournamentCurrentTurn === 'player2');
  if (!isMyTurn) return;

  // если это не первый ход, но кубики не брошены => выходим
  if (!tournamentHasRolledDice && tournamentFirstRollComplete) {
    return;
  }
  if (tournamentNumberMove === 0) return;




  let baseDice;
  if (tournamentFirstRollComplete && !firstMoveComplete) {
    // Первый ход: берём из tournamentFirstRolls
    if (tournamentPlayerColor === 'white') {
      baseDice = [tournamentFirstRolls.player1Roll, tournamentFirstRolls.player2Roll];
    } else {
      baseDice = [tournamentFirstRolls.player2Roll, tournamentFirstRolls.player1Roll];
    }
  } else {
    // Обычный ход: берём из tournamentRolledDice
    baseDice = [...tournamentRolledDice];
  }



  // -- 2) Бар: если есть захваченные, ходим только с бара --
  if (tournamentCapturedCheckers[tournamentPlayerColor] > 0) {
    const dragDataRaw = e.dataTransfer.getData('text');
    if (!dragDataRaw) return;
    const dragData = JSON.parse(dragDataRaw);
    if (!dragData.isFromBar) {
      alert(translate('jackpotBoard.enterFromBarFirst'));
      return;
    }
  }

  // -- 3) Извлекаем из dataTransfer --
  const dragDataRaw = e.dataTransfer.getData('text');
  if (!dragDataRaw) return;
  const { pointIndex, checkerIndex, isFromBar } = JSON.parse(dragDataRaw);

  // -- 4) Копируем board/captured --
  const newBoard = tournamentDeepCopyBoard(tournamentBoard);
  const updatedCaptured = { ...tournamentCapturedCheckers };

  // -- 5) Считаем moveDist --
  let moveDist;
  if (isFromBar) {
    moveDist = (tournamentPlayerColor === 'white')
      ? (24 - targetIndex)
      : (targetIndex + 1);
  } else {
    moveDist = (tournamentPlayerColor === 'white')
      ? (pointIndex - targetIndex)
      : (targetIndex - pointIndex);
  }

  // -- 6) Оставшиеся кубики (например [6,3] или дубль [4,4,4,4]) --
  let remainingRolls = tournamentCalculateRemainingRolls(
    // tournamentRolledDice,
    baseDice,
    tournamentUsedRolls
  );
  // сортируем по убыванию, если хотите
  remainingRolls.sort((a,b)=>b-a);

  // -- 7) Проверяем, что moveDist есть в leftover --
  if (!remainingRolls.includes(moveDist)) {
    console.log('[Drop] moveDist=', moveDist, 'нет в leftover=', remainingRolls);
    return;
  }

  // -- 8) Если mustUseTwoMoves===true, и у нас ещё >=2 ходов,
  //       запретим ход, который заблокирует использование
  //       второго кубика/кубиков.
  if (mustUseTwoMoves && tournamentNumberMove >= 2) {
    // 8а) Симулируем этот ход
    const firstMoveSim = simulateOneMove(newBoard, updatedCaptured, {
      fromIndex: isFromBar ? 25 : pointIndex,
      moveDist,
      playerColor: tournamentPlayerColor
    });
    if (!firstMoveSim) {
      // сам ход невозможен, выходим
      console.log('[Drop] simulateOneMove => null => ход невозможен');
      return;
    }

    // 8б) убираем moveDist из leftover
    const leftoverAfterThis = removeOneDistFromArray(remainingRolls, moveDist);

    // 8в) Проверяем, можем ли мы на `leftoverAfterThis[0]` (или все оставшиеся) сходить из newBoardAfter.
    //     Если *вообще не можем* сделать второй ход, значит блокируем.
    const canStillUseSecond = canMakeAtLeastOneMove(
      firstMoveSim.boardAfter,
      firstMoveSim.capturedAfter,
      leftoverAfterThis,
      tournamentPlayerColor
    );

    if (!canStillUseSecond) {
      alert(translate('jackpotBoard.secondDieBlocked'));
      return;
    }
  }

  // -- 9) Всё ок, выполняем реальный ход "по-настоящему" --
  let movingChecker;
  if (isFromBar) {
    if (updatedCaptured[tournamentPlayerColor] <= 0) {
      console.log('нет шашек на баре');
      return;
    }
    movingChecker = { color: tournamentPlayerColor };
    updatedCaptured[tournamentPlayerColor]--;
  } else {
    if (!newBoard[pointIndex] || !newBoard[pointIndex][checkerIndex]) {
      console.log('[Drop] Нет шашки на точке', pointIndex);
      return;
    }
    movingChecker = newBoard[pointIndex].splice(checkerIndex,1)[0];
  }

  // Bear-off dnd пока не рассматриваем:
  if (targetIndex < 0 || targetIndex>23) {
    console.log('[Drop] Bear-off DnD не реализовано');
    return;
  }

  // если на targetIndex >1 чужая => нельзя
  if (
    newBoard[targetIndex]?.length > 1 &&
    newBoard[targetIndex][0].color !== tournamentPlayerColor
  ) {
    console.log('[Drop] Там >1 чужая => нельзя');
    return;
  }

  // сбитие, если 1 чужая
  let capturedChecker = null;
  if (
    newBoard[targetIndex]?.length===1 &&
    newBoard[targetIndex][0].color!==tournamentPlayerColor
  ) {
    capturedChecker = newBoard[targetIndex].pop();
    updatedCaptured[capturedChecker.color] =
      (updatedCaptured[capturedChecker.color]||0)+1;
  }

  // ставим нашу
  newBoard[targetIndex] = newBoard[targetIndex]||[];
  newBoard[targetIndex].push(movingChecker);

  // -- 10) пишем в историю --
  const currentNumberMove = tournamentNumberMove;
  setTournamentMoveHistory(prev=>[
    ...prev,
    {
      from: isFromBar?25:pointIndex,
      to: targetIndex,
      board: tournamentDeepCopyBoard(newBoard),
      checker: movingChecker,
      capturedChecker,
      diceValuesUsed:[moveDist],
      updatedCapturedCheckers: {...updatedCaptured},
      numberMove: currentNumberMove
    }
  ]);

  // -- 11) Обновляем usedRolls / numberMove --
setTournamentUsedRolls((prev) => [
  ...prev,
  moveDist
]);

setTournamentNumberMove((prev) =>
  Math.max(Number(prev || 0) - 1, 0)
);

  // -- 12) Применяем локально --
  setTournamentBoard(newBoard);
  setTournamentCapturedCheckers(updatedCaptured);
  setTournamentLastMoveType('drag');

  // -- 13) Оповещаем сервер --
  tournamentSocket.emit('tournamentMatch_updateBoardState',{
    tableId: parseInt(tournamentTableId,10),
    boardState: newBoard,
    player: (tournamentPlayerColor==='white')?'player1':'player2',
    updatedCapturedCheckers: updatedCaptured,
    whiteOffBoard: tournamentWhiteOffBoard,
    blackOffBoard: tournamentBlackOffBoard,
    ephemeral: true
  });
}







/**
 * Проверяет, можем ли мы совершить хотя бы ОДИН ход из (dice1, dice2).
 * Упрощённый вариант (не учитывает бар, сбитие и т.д.).
 * Если нужно учесть бар — дополните логику.
 */
function checkSingleMovePossible(board, captured, offBoard, playerColor, d1, d2) {
  // Если дубль => 4 копии
  const diceArr = (d1 === d2)
    ? [d1, d1, d1, d1]
    : [d1, d2];

  for (let dist of diceArr) {
    const result = simulateOneMoveWithBarAndBearOff(
      board,
      captured,
      offBoard,
      dist,
      playerColor
    );
    if (result) {
      return true; 
    }
  }
  return false;
}





function canMakeAtLeastOneMove(board, captured, leftoverDice, playerColor) {
  // Пробуем каждый dist из leftoverDice
  for (let dist of leftoverDice) {
    // 1) Если есть шашки на баре (captured[playerColor] > 0), пробуем ход с бара
    if (captured[playerColor] > 0) {
      const simBar = simulateOneMove(board, captured, {
        fromIndex: 25,
        moveDist: dist,
        playerColor
      });
      if (simBar) {
        return true; // нашли хоть 1 вариант
      }
    }

    // 2) Пробуем ходить со всех пунктов 0..23
    for (let i=0; i<24; i++) {
      if (board[i]?.length && board[i][board[i].length - 1].color === playerColor) {
        const sim = simulateOneMove(board, captured, {
          fromIndex: i,
          moveDist: dist,
          playerColor
        });
        if (sim) {
          return true;
        }
      }
    }
  }
  return false;
}







function removeOneDistFromArray(diceArray, val) {
  const copy = [...diceArray];
  const idx = copy.indexOf(val);
  if (idx !== -1) {
    copy.splice(idx, 1);
  }
  return copy;
}



function simulateOneMove(originalBoard, originalCaptured, { fromIndex, moveDist, playerColor }) {
  // 1) Делаем копии
  const tempBoard = tournamentDeepCopyBoard(originalBoard);
  const tempCaptured = { ...originalCaptured };

  let targetIndex;
  if (playerColor === 'white') {
    targetIndex = fromIndex - moveDist;
  } else {
    targetIndex = fromIndex + moveDist;
  }

  // 2) Проверки границ
  if (targetIndex < 0 || targetIndex > 23) {
    return null;
  }

  // 3) Снимаем шашку (бар или доска)
  if (fromIndex === 25) {
    // бар
    if (tempCaptured[playerColor] <= 0) {
      return null;
    }
    tempCaptured[playerColor]--;
  } else {
    // доска
    if (!tempBoard[fromIndex]?.length) {
      return null;
    }
    const topChecker = tempBoard[fromIndex][tempBoard[fromIndex].length - 1];
    if (topChecker.color !== playerColor) {
      return null;
    }
    tempBoard[fromIndex].pop();
  }

  // 4) Если 2+ чужих на targetIndex => null
  if (
    tempBoard[targetIndex]?.length > 1 &&
    tempBoard[targetIndex][0].color !== playerColor
  ) {
    return null;
  }

  // 5) Если 1 чужая => сбиваем
  let capturedChecker = null;
  if (
    tempBoard[targetIndex]?.length === 1 &&
    tempBoard[targetIndex][0].color !== playerColor
  ) {
    capturedChecker = tempBoard[targetIndex].pop();
    const oppColor = capturedChecker.color;
    tempCaptured[oppColor] = (tempCaptured[oppColor] || 0) + 1;
  }

  // 6) Ставим свою
  tempBoard[targetIndex] = tempBoard[targetIndex] || [];
  tempBoard[targetIndex].push({ color: playerColor });

  // 7) Возвращаем объект
  return {
    boardAfter: tempBoard,
    capturedAfter: tempCaptured,
    capturedChecker // добавили
  };
}







// tournamentSocket.on('tournament_tableClosed', ({ tableId }) => {
//   try { localStorage.removeItem('tournamentTableId'); } catch (e) {}
//   // редирект/возврат в лобби у тебя уже реализован — он сработает
// });













function applyOneDieStep(tempBoard, playerColor, dieValue) {
  // Перебираем все ячейки доски (0..23)
  for (let fromIndex = 0; fromIndex < 24; fromIndex++) {
    // Проверяем, есть ли там шашка нашего цвета
    if (
      tempBoard[fromIndex] &&
      tempBoard[fromIndex].length > 0 &&
      tempBoard[fromIndex][0].color === playerColor
    ) {
      // Пытаемся сделать ход (одношаговый)
      const moved = simulateStepMove(tempBoard, fromIndex, dieValue, playerColor);
      if (moved) {
        // Если получилось, возвращаем true
        return true;
      }
    }
  }
  // Если не получилось ни одной шашкой
  return false;
}



/**
 * simulateStepMove
 * Пытается «одним ходом» (dieValue) сдвинуть шашку с fromIndex.
 * Если ход возможен, вносит изменения "на месте" в tempBoard и возвращает true.
 * Если заблокировано/невозможно, возвращает false.
 */
function simulateStepMove(tempBoard, fromIndex, dieValue, playerColor) {
  let targetIndex;
  if (playerColor === 'white') {
    targetIndex = fromIndex - dieValue;
  } else {
    targetIndex = fromIndex + dieValue;
  }

  // 1) Проверка выхода за границы
  //    (Если хотите обрабатывать bear-off, добавьте логику тут)
  if (targetIndex < 0 || targetIndex > 23) {
    return false;
  }

  // 2) Проверка, есть ли "наша" шашка сверху на fromIndex
  if (!tempBoard[fromIndex] || tempBoard[fromIndex].length === 0) {
    return false;
  }
  if (tempBoard[fromIndex][0].color !== playerColor) {
    return false;
  }

  // 3) Проверяем, не >1 ли чужих на targetIndex
  if (
    tempBoard[targetIndex]?.length > 1 &&
    tempBoard[targetIndex][0].color !== playerColor
  ) {
    return false;
  }

  // 4) Снимаем нашу шашку (верхнюю) с fromIndex
  const movingChecker = tempBoard[fromIndex].shift(); // убираем индекс 0

  // 5) Если на targetIndex ровно 1 чужая — сбиваем
  if (
    tempBoard[targetIndex]?.length === 1 &&
    tempBoard[targetIndex][0].color !== playerColor
  ) {
    // Убираем чужую шашку
    tempBoard[targetIndex].pop();
    // При необходимости capturedCheckers[oppColor]++
  }

  // 6) Ставим нашу
  tempBoard[targetIndex] = tempBoard[targetIndex] || [];
  tempBoard[targetIndex].unshift(movingChecker);

  return true;
}





function checkFourMovesPossible(board, playerColor, dieValue) {
  // 1) Делаем копию доски, чтобы не портить оригинал.
  //    У вас может называться tournamentDeepCopyBoard(...) или deepCopyBoard(...).
  const tempBoard = tournamentDeepCopyBoard(board);

  let usedCount = 0; // Сколько раз удалось сходить
  // 2) Четыре раза пытаемся применить "один" ход на dieValue
  for (let i = 0; i < 4; i++) {
    // applyOneDieStep(...) — см. ниже
    const success = applyOneDieStep(tempBoard, playerColor, dieValue);
    if (success) {
      usedCount++; // Если получилось
    }
    // Если нет, пропускаем конкретный бросок — классика нард
  }

  return usedCount; // 0..4
}

// Получить индексы точек (0..23), на которых лежит *хотя бы одна* наша шашка
function getMyPoints(board, playerColor) {
  const arr = [];
  for (let i = 0; i < 24; i++) {
    if (board[i]?.length > 0 && board[i][0].color === playerColor) {
      arr.push(i);
    }
  }
  return arr;
}

// Проверяем, можно ли "двумя РАЗНЫМИ шашками" сходить
//   - сначала на distanceA,
//   - потом другой шашкой на distanceB.
function canUseTwoDifferentCheckers(board, myPoints, distanceA, distanceB, playerColor) {
  // Проходим по всем парам (p1, p2), p1 != p2
  for (let i = 0; i < myPoints.length; i++) {
    const from1 = myPoints[i];
    // 1) Пробуем сходить шашкой с from1 на distanceA
    const boardAfter1 = simulateMove(board, from1, distanceA, playerColor);
    if (!boardAfter1) continue; // ход невозможен

    // На новой доске ищем *другую* точку для хода distanceB
    for (let j = 0; j < myPoints.length; j++) {
      const from2 = myPoints[j];
      if (from2 === from1) continue; // другая шашка
      const boardAfter2 = simulateMove(boardAfter1, from2, distanceB, playerColor);
      if (boardAfter2) {
        // Ура, нашли способ сходить
        return true;
      }
    }
  }
  return false;
}

// Проверяем, можно ли ОДНОЙ и той же шашкой сходить
// сначала distanceA, потом distanceB
function canUseSameChecker(board, myPoints, distanceA, distanceB, playerColor) {
  for (let i = 0; i < myPoints.length; i++) {
    const fromIndex = myPoints[i];
    // (1) первый ход
    const boardAfter1 = simulateMove(board, fromIndex, distanceA, playerColor);
    if (!boardAfter1) continue;

    // Шашка теперь на targetIndex= fromIndex ± distanceA
    let targetIndex = (playerColor === 'white')
      ? (fromIndex - distanceA)
      : (fromIndex + distanceA);
    if (targetIndex < 0 || targetIndex >= 24) continue;

    // (2) второй ход — снова двигаем ЭТУ ЖЕ шашку
    const boardAfter2 = simulateMove(boardAfter1, targetIndex, distanceB, playerColor);
    if (boardAfter2) {
      return true;
    }
  }
  return false;
}

/**
 * Простейшая "симуляция хода": пытается сдвинуть верхнюю шашку playerColor на distance
 * Возвращает новую копию board или null, если ход невозможен.
 *  - Без учёта сбития, бара, etc.
 *  - Просто проверим: if (dst < 0 || dst>23) => impossible
 *  - Если targetPoint уже занята чужими >1 => тоже impossible
 *  - И т.д.
 */
function simulateMove(board, fromIndex, distance, playerColor) {
  const newBoard = deepCopyBoard(board);
  // Проверим, есть ли там наша шашка
  if (!newBoard[fromIndex] || newBoard[fromIndex].length === 0) return null;
  if (newBoard[fromIndex][0].color !== playerColor) return null;

  // targetIndex
  let targetIndex;
  if (playerColor === 'white') {
    targetIndex = fromIndex - distance;
  } else {
    targetIndex = fromIndex + distance;
  }
  if (targetIndex < 0 || targetIndex > 23) {
    return null;
  }

  // Проверяем, нет ли там 2+ чужих
  if (newBoard[targetIndex]?.length > 1 && newBoard[targetIndex][0].color !== playerColor) {
    return null;
  }

  // Двигаем
  const movingChecker = newBoard[fromIndex].shift(); // забираем верхнюю
  newBoard[targetIndex] = newBoard[targetIndex] || [];
  newBoard[targetIndex].unshift(movingChecker); // кладём наверх

  return newBoard;
}

// Копия доски (поверхностно-глубокая для массива шашек)
function deepCopyBoard(board) {
  return board.map(stack => stack.map(ch => ({ ...ch })));
}


if (tournamentLoading) return <div>{translate('jackpotBoard.loading')}</div>;
if (tournamentError) return <div style={{ color: 'red' }}>{translate('jackpotBoard.errorPrefix')} {tournamentError}</div>;


  return (
    <div>
   
  
       <TournamentBoardDisplay
    
        tournamentBoard={tournamentBoard}
        currentTurn={tournamentCurrentTurn}
        tournamentFirstRolls={tournamentFirstRolls}
        handleTournamentFirstMove = {handleTournamentFirstMove}
        tournamentConfirmMove = {tournamentConfirmMove}
        tournamentHasRolledDice = {tournamentHasRolledDice}
        tournamentPlayer1Roll={tournamentFirstRolls?.player1Roll}
        tournamentPlayer2Roll={tournamentFirstRolls?.player2Roll}
        tournamentCountdown={countdown}
        // tournamentHandleReadyClick={handleTournamentReadyClick}
     
        tournamentShowReadyButton={!rollButtonEnabled && countdown !== null}
        // tournamentShowReadyButton = {tournamentShowReadyButton}
        tournamentPlayer1Name = {tournamentPlayer1Name}
        tournamentPlayer2Name = {tournamentPlayer2Name}
        tournamentCurrentTurn={tournamentCurrentTurn}
        countdownMessage = {countdownMessage}
        handleTournamentRollDiceClick={handleTournamentRollDiceClick}  
        tournamentShowUndoButton={tournamentShowUndoButton} // Настройте при необходимости
        tournamentNumberMove={tournamentNumberMove}
        // tournamentConfirmMove={() => {}} // Настройте при необходимости
        tournamentWhiteOffBoard={tournamentWhiteOffBoard}
        tournamentSetWhiteOffBoard={setTournamentWhiteOffBoard}
        tournamentBlackOffBoard={tournamentBlackOffBoard}
        tournamentSetBlackOffBoard={setTournamentBlackOffBoard}
        // tournamentHandleDragStart={() => {}} // Настройте при необходимости
        tournamentHandleDragStart = {tournamentHandleDragStart}
        
        tournamentHandleDrop = {tournamentHandleDrop}
        tournamentOnPointClick = {tournamentOnPointClick}
        handleTournamentDragOver = {handleTournamentDragOver}
        tournamentFirstRollComplete = {tournamentFirstRollComplete}
        firstMoveComplete = {firstMoveComplete}
        tournamentHandleUndoMove = {tournamentHandleUndoMove}
        tournamentOnCheckerClick = {tournamentOnCheckerClick}
        player1Time = {player1Time}
        player2Time = {player2Time}
        modalMessage = {modalMessage}
        showModal = {showModal}
        tournamentShowSurrenderButton={true}           
        tournamentHandleSurrender={handleTournamentSurrender}  
  /* ▼ ДОБАВИТЬ: аватарки и короткий рейтинг */
  player1Avatar={player1Avatar}
  player2Avatar={player2Avatar}
  player1ShortRating={player1ShortRating}
  player2ShortRating={player2ShortRating}
  tournamentStageLabel={tournamentStageLabel}
  tournamentId={tournamentId}
      tournamentPrize={tournamentPrize}

       autoRoll = {autoRoll}
      autoConfirm = {autoConfirm}
      onToggleAutoRoll = {onToggleAutoRoll}
      onToggleAutoConfirm  = {onToggleAutoConfirm }

      
      />
<MatchResultModalV2
  show={showModal}
  outcome={lastOutcome || {}}
  message={modalMessage}
  prize={tournamentPrize}
  stageLabel={tournamentStageLabel}
  currentUser={tournamentUsername}  // ← вот так
  bracketRounds={bracketRounds}
  onClose={() => setShowModal(false)}
  onPrimary={() => { setShowModal(false); navigate("/"); }}
  onSecondary={() => {
    const parts = [
      `[${tournamentStageLabel || translate('jackpotBoard.match')}]`,
      lastOutcome?.isFinal ? translate('jackpotBoard.finalUpper') : '',
      lastOutcome?.winner ? translate('jackpotBoard.copyWinner', { winner: lastOutcome.winner }) : '',
      lastOutcome?.loser ? translate('jackpotBoard.copyLoser', { loser: lastOutcome.loser }) : '',
      modalMessage ? `\n${modalMessage}` : "",
    ].filter(Boolean);
    const txt = parts.join(" ");
    navigator.clipboard?.writeText(txt);
  }}
/>




    </div>
  ); 
};

export default TournamentMatch;




















